/**
 * Libs (rendo disponibili globalmente)
 */
import Utilities from "./lib/Utilities";
import Form from "./lib/Form";
window.Form = Form;
window.Utilities = Utilities;

/**
 * Componenti Alpine (Alpine è fornito da Livewire)
 * Registrati globalmente perché gli script inline nei container barba non vengono eseguiti
 */
import moodboard from "./lib/Moodboard";
function registerAlpineComponents() {
    window.Alpine.data('moodboard', moodboard);
}
if (window.Alpine) {
    registerAlpineComponents();
} else {
    document.addEventListener('alpine:init', registerAlpineComponents);
}

var debugMode = window.ENV == 'local';

/**
 * Click su un link dentro [data-scroll-on-click]: porta al top della pagina
 * l'antenato [data-scroll-target] (es. menu della materioteca, i cui link
 * aggiornano il contenuto via Livewire senza cambio pagina). Delegato sul
 * document perché i link vengono ricreati dai morph Livewire e dai cambi
 * pagina barba. Usa data-anchor-offset del target, se presente.
 *
 * Se il target ha data-scroll-dest (selettore) si va invece a quell'elemento,
 * sotto il target sticky (v. scrollBelowStickyNav). Non data-scroll-to:
 * locomotive lo usa per i suoi link di scroll e intercetterebbe i click.
 */
document.addEventListener('click', function (e) {
    const link = e.target.closest && e.target.closest('[data-scroll-on-click] a');
    const el = link && link.closest('[data-scroll-target]');
    if (!el) {
        return;
    }

    const scrollDest = el.getAttribute('data-scroll-dest');
    if (scrollDest) {
        scrollBelowStickyNav(el, document.querySelector(scrollDest));
        return;
    }

    const offset = parseInt(el.getAttribute('data-anchor-offset')) || 0;

    if (window.locomotiveScroll) {
        window.locomotiveScroll.scrollTo(el, {offset: -offset});
    } else {
        const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({top, behavior: 'smooth'});
    }
});

/**
 * Scrolla a dest lasciando sopra lo spazio per la nav sticky (.c-sticky-nav),
 * es. inizio della lista prodotti al click su una voce della nav o
 * all'applicazione di un filtro. L'header non riappare anche se lo scroll è
 * verso l'alto (v. suppressHeaderReveal); verso il basso si nasconde da solo.
 * Globale: usata anche dagli script dei componenti Livewire.
 */
function scrollBelowStickyNav(nav, dest) {

    const offset = nav.offsetHeight;
    const distance = dest ? dest.getBoundingClientRect().top - offset : 0;
    if (Math.abs(distance) < 1) {
        return;
    }

    const up = distance < 0;
    if (up) {
        suppressHeaderReveal();
    }

    if (window.locomotiveScroll) {
        window.locomotiveScroll.scrollTo(dest, {offset: -offset, onComplete: up ? releaseHeaderReveal : undefined});
    } else {
        window.scrollTo({top: window.pageYOffset + distance, behavior: 'instant'});
    }
}
window.scrollBelowStickyNav = scrollBelowStickyNav;

/**
 * DOM ready
 */
$(function() {

});


/**
 * Load
 */
$(window).on("load", function() {

    /**
     * Init di barba
     * Deve essere incluso nella blade base!
     * L'evento "loadermanager-page_loaded" viene lanciato quando la coda
     * di LoaderManager è stata svuotata
     */
    $(document).on("loadermanager-page_loaded", function() {

        // init manuale di lazysizes (cfg.init = false in vendor.js)
        lazySizes.init();

        locomotiveScrollInit();

        barbaInit();

        initSeguiMouse();

        pageEnter();

        $('body').removeClass('loading');
        
        //gallery tipo marquee
        //initGalleryFreeMode();


    });


    /**
     * Configurazione globale componenti uikit
    (function() {
        // container false per modal, evita duplicazione elemento in seguito a caricamenti asincroni (barba.js)
        UIkit.mixin({
            data: {
                container: false,
            }
        }, 'modal');
    })();
     */


    /**
     * Update necessari dopo caricamenti livewire
    */
    Livewire.hook('message.processed', function () {
      
        // scroll a eventuale messaggio di errore form
        scrollToFormError();

    });


    // scroll a eventuale messaggio di errore form, al caricamento!
    scrollToFormError();
        
    
    /**
     * Fine caricamento
     */
    LoaderManager.eventComplete("site_loading");


});


/**
 * Scroll al primo messaggio di errore di un form.
 * TODO: lo scroll vero e proprio non è ancora implementato, per ora
 * la funzione si limita a verificare se un errore è presente.
 */
function scrollToFormError()
{
    if (!$('form .field__error').length) {
        return;
    }

}


/**
 * Velo bianco dei cambi pagina (#page_loader) animato a tendina: entra dal
 * basso fino a coprire la viewport (pageExit) ed esce continuando verso
 * l'alto (pageEnter). Resta sotto all'header, che durante il cambio pagina
 * è sempre in positivo (v. lockHeaderModePositive).
 * Insieme alla tendina si sposta anche il container barba: quello che esce
 * sale di PAGE_SHIFT mentre viene coperto, quello che entra sale da
 * +PAGE_SHIFT mentre viene scoperto (niente spostamento con "riduci animazioni").
 */
var PAGE_CURTAIN_LEAVE_DURATION = 0.8; // s
var PAGE_CURTAIN_ENTER_DURATION = 1; // s
var PAGE_SHIFT = '15vh';
var PAGE_CURTAIN_EASE = CustomEase.create('pageCurtain', '0.625, 0.05, 0, 1');

// soglia (progresso con easing) dell'uscita della tendina oltre la quale il
// suo bordo inferiore è quasi arrivato all'header (v. pageEnter)
var PAGE_CURTAIN_HEADER_UNLOCK = 0.85;

function pageShiftEnabled() {
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}


/**
 * Funzione di uscita pagina
 */
function pageExit(callback, container){
    if(debugMode){console.log("-----page EXIT")}

    var loader = document.getElementById('page_loader');

    // la pagina corrente sale mentre la tendina la copre (viene poi rimossa da barba)
    if (container && pageShiftEnabled()) {
        gsap.to(container, {
            y: '-' + PAGE_SHIFT,
            duration: PAGE_CURTAIN_LEAVE_DURATION,
            ease: PAGE_CURTAIN_EASE
        });
    }

    // porto in primo piano prima di iniziare animazione, con la tendina chiusa in basso
    gsap.killTweensOf(loader);
    gsap.set(loader, {
        zIndex: 49, // sotto all'header!
        opacity: 1,
        clipPath: 'inset(100% 0% 0% 0%)'
    });

    //animazione in uscita dalla pagina (la tendina sale fino a coprire la pagina)
    gsap.to(loader, {
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: PAGE_CURTAIN_LEAVE_DURATION,
        ease: PAGE_CURTAIN_EASE,
        onComplete: function() {

            if (locomotiveScroll) {
                locomotiveScroll.start();
            }

            if (callback && typeof(callback) == 'function') {
                callback();
            }
        }
    });
}


/**
 * Testo che si rivela parola per parola quando entra nel viewport
 * (v. componente x-text-reveal): ogni [data-text-reveal] viene splittato
 * in parole via GSAP SplitText e animato da opacity 0.1 a 1 con uno
 * stagger, triggerato dallo scroll (ScrollTrigger).
 * Con prefers-reduced-motion, niente split/animazione
 */
function initTextReveal(container) {

    var scope = container || document;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scope.querySelectorAll('[data-text-reveal]').forEach(function (el) {

        // già inizializzato (es. elemento fuori dal container di barba)
        if (el.__textRevealSplit) { return; }

        if (reducedMotion) {
            gsap.set(el, { opacity: 1 });
            return;
        }

        var split = new SplitText(el, { type: 'words', wordsClass: 'word' });

        // il .1 iniziale (v. [data-text-reveal] in main.scss) passa dal
        // blocco intero alle singole parole, senza flash intermedio
        gsap.set(el, { opacity: 1 });
        gsap.set(split.words, { opacity: 0.1 });

        el.__textRevealSplit = split;
        el.__textRevealTween = gsap.to(split.words, {
            opacity: 1,
            stagger: 0.20,
            ease: 'none',
            scrollTrigger: {
                trigger: el,
                start: 'top 85%',
                toggleActions: 'play none none none'
            }
        });
    });
}

/**
 * Ripulisce le animazioni di initTextReveal() prima che il container
 * venga sostituito da barba (v. transitions[].leave sotto).
 */
function killTextReveal(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-text-reveal]').forEach(function (el) {

        if (el.__textRevealTween) {
            if (el.__textRevealTween.scrollTrigger) {
                el.__textRevealTween.scrollTrigger.kill();
            }
            el.__textRevealTween.kill();
            el.__textRevealTween = null;
        }

        if (el.__textRevealSplit) {
            el.__textRevealSplit.revert();
            el.__textRevealSplit = null;
        }
    });
}


/**
 * Fade di opacity legato allo scroll (v. [data-scroll-opacity]). Locomotive
 * Scroll non gestisce nativamente l'opacity (solo il parallax via
 * data-scroll-speed): seguiamo la stessa convenzione dichiarativa ma
 * pilotando l'animazione con GSAP ScrollTrigger, già sincronizzato con lo
 * scroll smoothato di locomotive-scroll (v. ScrollTrigger.update() in
 * locomotiveScrollInit()). data-scroll-opacity-from/-to impostano il range
 * (default 0.7 -> 0.3). data-scroll-opacity-trigger (selettore, cercato con
 * closest) usa come riferimento per lo scroll un antenato invece
 * dell'elemento stesso: utile quando l'elemento cambia geometria via JS
 * (es. media dell'intro in home).
 */
function initScrollOpacity(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-scroll-opacity]').forEach(function (el) {

        // già inizializzato (es. elemento fuori dal container di barba)
        if (el.__scrollOpacityTween) { return; }

        var fromAttr = el.getAttribute('data-scroll-opacity-from');
        var toAttr = el.getAttribute('data-scroll-opacity-to');
        var from = fromAttr !== null ? parseFloat(fromAttr) : 0.7;
        var to = toAttr !== null ? parseFloat(toAttr) : 0.3;

        var triggerAttr = el.getAttribute('data-scroll-opacity-trigger');
        var trigger = (triggerAttr && el.closest(triggerAttr)) || el;

        gsap.set(el, { opacity: from });

        el.__scrollOpacityTween = gsap.to(el, {
            opacity: to,
            ease: 'none',
            scrollTrigger: {
                trigger: trigger,
                start: 'top top',
                end: 'bottom top',
                scrub: true,
            }
        });
    });
}

/**
 * Ripulisce le animazioni di initScrollOpacity() prima che il container
 * venga sostituito da barba (v. transitions[].leave sotto).
 */
function killScrollOpacity(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-scroll-opacity]').forEach(function (el) {

        if (el.__scrollOpacityTween) {
            if (el.__scrollOpacityTween.scrollTrigger) {
                el.__scrollOpacityTween.scrollTrigger.kill();
            }
            el.__scrollOpacityTween.kill();
            el.__scrollOpacityTween = null;
        }
    });
}


/**
 * Intro a due colonne con immagine sticky (v. [data-split-resize] in
 * about.blade.php): allo scroll la colonna immagine si stringe da 50% a 25%
 * (sfumando a opacity 0.5) e quella dei testi si allarga da 50% a 75%.
 * Lo sticky è CSS (md:sticky sul contenitore dell'immagine) e si rilascia da
 * solo a fine section. Solo >= SPLIT_RESIZE_MIN_WIDTH: gsap.matchMedia rimuove
 * gli stili inline scendendo sotto il breakpoint e ricrea l'animazione risalendo.
 */
// animazione riservata agli schermi grandi (breakpoint "xl" del progetto,
// v. --breakpoint-xl in _theme.scss): esclusi mobile e tablet
var SPLIT_RESIZE_MIN_WIDTH = 1600;

function initSplitResize(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-split-resize]').forEach(function (root) {

        // già inizializzato (es. elemento fuori dal container di barba)
        if (root.__splitResize) { return; }

        var img = root.querySelector('[data-split-resize-img]');
        var content = root.querySelector('[data-split-resize-content]');
        if (!img || !content) { return; }

        var mm = gsap.matchMedia();

        mm.add('(min-width: ' + SPLIT_RESIZE_MIN_WIDTH + 'px)', function () {

            var tl = gsap.timeline({
                defaults: { ease: 'none' },
                scrollTrigger: {
                    trigger: root,
                    start: 'top top',
                    end: '+=80%',
                    scrub: 1.2,
                },
            });

            tl.fromTo(img, { width: '50%' }, { width: '25%' }, 0)
              .fromTo(img.querySelector('img'), { opacity: 1 }, { opacity: 0.5 }, 0)
              .fromTo(content, { width: '50%' }, { width: '75%' }, 0);
        });

        root.__splitResize = mm;
    });
}

/**
 * Ripulisce initSplitResize() prima che il container venga sostituito da
 * barba (v. transitions[].leave sotto): revert() rimuove anche gli stili inline.
 */
function killSplitResize(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-split-resize]').forEach(function (root) {

        if (root.__splitResize) {
            root.__splitResize.revert();
            root.__splitResize = null;
        }
    });
}


/**
 * Slider drag/parallax (v. [data-parallax-init] in section.progetti,
 * homepage.blade.php): un'istanza Smooothy per wrapper, con parallax
 * dell'immagine dentro ogni slide pilotato da onUpdate.
 * Il markup contiene ogni slide una sola volta: i cloni per il loop
 * infinito li aggiunge syncSlides() in base alla larghezza disponibile.
 */
function initParallaxSlider(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-parallax-init]').forEach(function (root) {

        // già inizializzato (es. elemento fuori dal container di barba)
        if (root.__parallaxSlider) { return; }

        var wrapper = root.querySelector('[data-parallax-slider]');
        if (!wrapper) { return; }

        // slide stampate dal server (senza i cloni aggiunti da syncSlides)
        var originals = [...wrapper.children];
        if (!originals.length) { return; }

        // un layer di parallax per slide (facoltativo), cloni compresi
        var getParallaxItems = function () {
            return [...wrapper.children].map(function (slide) {
                return slide.querySelector('[data-parallax-inner]');
            });
        };
        var parallaxItems = getParallaxItems();

        var amountAttr = wrapper.getAttribute('data-parallax-amount');
        var amount = amountAttr !== null ? parseFloat(amountAttr) : 12;

        var snap = wrapper.getAttribute('data-parallax-snap') !== 'false';
        var infinite = wrapper.getAttribute('data-parallax-infinite') !== 'false';

        var lerpAttr = wrapper.getAttribute('data-parallax-lerp');
        // per Smooothy è una costante di tempo (s): più alto = più lento
        var lerp = lerpAttr !== null ? parseFloat(lerpAttr) : 0.5;

        // spostamento per px trascinato (default di Smooothy 0.005)
        var dragAttr = wrapper.getAttribute('data-parallax-drag-sensitivity');
        var dragSensitivity = dragAttr !== null ? parseFloat(dragAttr) : 0.003;

        /*
         * su mobile riduco lo smoothing 
         */
        var lerpMobileAttr = wrapper.getAttribute('data-parallax-lerp-mobile');
        var lerpMobile = lerpMobileAttr !== null ? parseFloat(lerpMobileAttr) : 0.05;
        if (window.innerWidth < INTRO_ANIM_MIN_WIDTH) {
            lerp = lerpMobile;
        }

        var maxOffset = 25;

        var slider = new Smooothy(wrapper, {
            infinite: infinite,
            snap: snap,
            lerpFactor: lerp,
            dragSensitivity: dragSensitivity,
            onUpdate: function ({ parallaxValues }) {
                parallaxItems.forEach(function (item, i) {
                    if (!item) { return; }
                    var offset = gsap.utils.clamp(-maxOffset, maxOffset, parallaxValues[i] * amount);
                    item.style.transform = 'translateX(' + offset + '%)';
                });
            },
        });

        /*
         * Cloni e slider "statico". In modalità infinite Smooothy distribuisce
         * le slide metà a destra e metà a sinistra della prima, quindi per non
         * lasciare buchi durante il drag ne servono almeno
         * 2 * (slide visibili + 1): si aggiungono copie complete della lista
         * finché non si arriva a quel numero (i cloni restano anche se la
         * finestra si stringe). Se invece le slide originali stanno tutte nel
         * wrapper lo slider non serve: via i cloni, drag e aree prev/next
         * disattivati, slide ferme nella posizione naturale.
         * Ricalcolato a ogni resize del wrapper, compreso il passaggio da
         * pannello nascosto a visibile (v. initProdottiTabs).
         */
        var isStatic = false;

        var cloneSlide = function (slide) {
            var clone = slide.cloneNode(true);
            clone.setAttribute('data-parallax-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button').forEach(function (el) {
                el.setAttribute('tabindex', '-1');
            });
            return clone;
        };

        var syncSlides = function () {
            var wrapperWidth = wrapper.clientWidth;
            var slideWidth = originals[0].getBoundingClientRect().width;

            // pannello nascosto: si ricalcola quando torna visibile
            if (!wrapperWidth || !slideWidth) { return; }

            var clones = wrapper.querySelectorAll(':scope > [data-parallax-clone]');
            var fits = originals.length * slideWidth <= wrapperWidth + 1;

            if (fits) {
                clones.forEach(function (clone) { clone.remove(); });
            } else if (infinite) {
                var needed = 2 * (Math.ceil(wrapperWidth / slideWidth) + 1);
                var count = originals.length + clones.length;
                while (count < needed) {
                    originals.forEach(function (slide) {
                        wrapper.appendChild(cloneSlide(slide));
                    });
                    count += originals.length;
                }
            }

            var wasStatic = isStatic;
            isStatic = fits;

            slider.items = [...wrapper.children];
            parallaxItems = getParallaxItems();

            // da statico niente loop: con current a 0 le slide restano a translateX(0)
            slider.config.infinite = infinite && !isStatic;
            slider.paused = isStatic;

            if (isStatic && !wasStatic) {
                slider.kill();
                wrapper.style.cursor = '';
            } else if (!isStatic && wasStatic) {
                slider.init();
                wrapper.style.cursor = 'grab';
            }

            slider.resize();
        };

        syncSlides();

        var resizeObserver = new ResizeObserver(syncSlides);
        resizeObserver.observe(wrapper);

        var tick = function () { slider.update(); };
        gsap.ticker.add(tick);

        /*
         * aree prev/next con l'icona che segue il mouse (v. createHoverNav):
         * le slide sono link a tutta superficie, quindi niente metà ma due fasce
         * ai lati (100px, o [data-parallax-hover-nav-edge] sul root) che hanno
         * la precedenza sul link sottostante. Il click è intercettato in fase di
         * cattura sul root, prima che arrivi al link (v. onNavClick sotto).
         */
        var hoverNav = createHoverNav(wrapper, {
            edge: parseInt(root.getAttribute('data-parallax-hover-nav-edge'), 10) || 100,
            canPrev: function () { return !isStatic; },
            canNext: function () { return !isStatic; },
        });

        /*
         * Evita che un drag sullo slider faccia scattare la navigazione dei
         * link dentro le slide (v. <a> attorno alle immagini in
         * homepage.blade.php): smooothy non distingue da sé un drag da un
         * click, quindi tracciamo lo spostamento tra down e up e, se supera
         * una piccola soglia, annulliamo il click successivo in fase di
         * cattura (il "click" arriva sempre dopo mouseup/touchend).
         */
        var dragClickThreshold = 6; // px
        var isPointerDown = false;
        var pointerMoved = false;
        var pointerDownX = 0;
        var pointerDownY = 0;

        var onPointerDown = function (e) {
            var point = e.touches ? e.touches[0] : e;
            isPointerDown = true;
            pointerMoved = false;
            pointerDownX = point.clientX;
            pointerDownY = point.clientY;
        };

        var onPointerMove = function (e) {
            if (!isPointerDown || pointerMoved) { return; }
            var point = e.touches ? e.touches[0] : e;
            var dx = point.clientX - pointerDownX;
            var dy = point.clientY - pointerDownY;
            if (Math.sqrt(dx * dx + dy * dy) > dragClickThreshold) {
                pointerMoved = true;
            }
        };

        var onPointerUp = function () {
            isPointerDown = false;
            // smooothy rimette il cursore "grab" a ogni mouseup, anche da fermo
            if (isStatic) { wrapper.style.cursor = ''; }
        };

        var onClickCapture = function (e) {
            if (pointerMoved && !isStatic) {
                e.preventDefault();
                e.stopPropagation();
            }
            pointerMoved = false;
        };

        // click su un'area prev/next: niente link, niente navigazione se era un drag
        var onNavClick = function (e) {
            var side = hoverNav.getSide(e);
            if (!side) { return; }

            e.preventDefault();
            e.stopPropagation();

            if (!pointerMoved) {
                if (side === 'prev') { slider.goToPrev(); }
                if (side === 'next') { slider.goToNext(); }
            }
            pointerMoved = false;
        };

        wrapper.addEventListener('mousedown', onPointerDown);
        wrapper.addEventListener('touchstart', onPointerDown, { passive: true });
        window.addEventListener('mousemove', onPointerMove);
        window.addEventListener('touchmove', onPointerMove, { passive: true });
        window.addEventListener('mouseup', onPointerUp);
        window.addEventListener('touchend', onPointerUp);
        wrapper.addEventListener('click', onClickCapture, true);
        root.addEventListener('click', onNavClick, true);

        root.__parallaxSlider = slider;
        root.__parallaxSliderTick = tick;
        root.__parallaxSliderCleanup = function () {
            wrapper.removeEventListener('mousedown', onPointerDown);
            wrapper.removeEventListener('touchstart', onPointerDown);
            window.removeEventListener('mousemove', onPointerMove);
            window.removeEventListener('touchmove', onPointerMove);
            window.removeEventListener('mouseup', onPointerUp);
            window.removeEventListener('touchend', onPointerUp);
            wrapper.removeEventListener('click', onClickCapture, true);
            root.removeEventListener('click', onNavClick, true);
            hoverNav.destroy();
            resizeObserver.disconnect();
        };
    });
}

// Pin/scroll-reveal a slide impilate riservato a schermi >= md: deve combaciare con i
// prefissi md: usati nel markup (es. prodotti-collezioni-outdoor.blade.php,
// professionisti.blade.php: md:sticky, md:absolute, ecc.).
// Sotto questa soglia le slide restano in flusso normale, formattate via CSS
// lato mobile (v. initStackReveal).
var STACK_REVEAL_MIN_WIDTH = 768;

/**
 * Raggruppa le [data-stack-slide] "sciolte" creando a
 * runtime i due wrapper che initStackReveal si aspetta: [data-stack-reveal]
 * (altezza = slide * 100dvh, con --slides) e il contenitore sticky interno.
 * Si raggruppano solo le slide adiacenti (fratelli consecutivi): un altro
 * elemento in mezzo genera due gruppi distinti, ognuno col suo pin. Le slide
 * già dentro un [data-stack-reveal] scritto a mano nel markup vengono ignorate.
 */
function wrapStackSlides(scope) {

    var groups = [];
    var current = null;

    scope.querySelectorAll('[data-stack-slide]').forEach(function (slide) {

        if (slide.closest('[data-stack-reveal], [data-widgets-slider]')) { return; }

        var prev = current && current[current.length - 1];

        if (prev && slide.previousElementSibling === prev && slide.getAttribute('data-stack-slide') === prev.getAttribute('data-stack-slide')) {
            current.push(slide);
        } else {
            current = [slide];
            groups.push(current);
        }
    });

    groups.forEach(function (slides) {

        var root = document.createElement('div');
        root.setAttribute('data-stack-reveal', '');
        root.style.setProperty('--slides', slides.length);
        root.className = 'md:h-[calc(var(--slides)*100dvh)]';

        var sticky = document.createElement('div');
        sticky.className = 'md:sticky md:top-0 md:h-dvh md:overflow-hidden';
        root.appendChild(sticky);

        slides[0].parentNode.insertBefore(root, slides[0]);

        slides.forEach(function (slide, i) {
            slide.style.zIndex = i + 1;
            sticky.appendChild(slide);
        });
    });
}

/**
 * Pin/scroll-reveal a slide impilate (v. [data-stack-reveal] e [data-stack-slide]
 * in prodotti-collezioni-outdoor.blade.php, professionisti.blade.php): la ul resta sticky in cima
 * (h-dvh) mentre il wrapper la tiene "agganciata" per tutta l'altezza delle
 * slide; le slide stesse sono impilate in absolute inset-0 dentro la ul (di
 * fatto ferme sullo schermo quando la ul è agganciata) e vengono svelate una
 * alla volta con un wipe dal basso via clip-path, invece di impilarsi con
 * position:sticky nativo su ogni <li>. Sotto STACK_REVEAL_MIN_WIDTH non
 * fa nulla: le slide restano in flusso normale (v. killStackReveal per
 * il resize da desktop a mobile).
 */
function initStackReveal(container) {

    var scope = container || document;

    if (window.innerWidth < STACK_REVEAL_MIN_WIDTH) { return; }

    wrapStackSlides(scope);

    scope.querySelectorAll('[data-stack-reveal]').forEach(function (root) {

        // già inizializzato (es. elemento fuori dal container di barba)
        if (root.__stackReveal) { return; }

        var slides = root.querySelectorAll('[data-stack-slide]');
        if (slides.length < 2) { return; }

        gsap.set(slides[0], { clipPath: 'inset(0% 0% 0% 0%)' });
        gsap.set(Array.from(slides).slice(1), { clipPath: 'inset(100% 0% 0% 0%)' });

        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: root,
                start: 'top top',
                end: 'bottom bottom',
                scrub: 1,
            },
        });

        for (var i = 1; i < slides.length; i++) {
            tl.to(slides[i], { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none', duration: 1 });
        }

        root.__stackReveal = tl;
    });

    // il wrapping (v. wrapStackSlides) e il pin cambiano l'altezza della
    // pagina: senza un refresh start/end di ScrollTrigger restano calcolati
    // sul layout precedente
    requestAnimationFrame(function () {
        ScrollTrigger.refresh();
    });
}

/**
 * Le immagini lazyload (lazysizes) e i font cambiano l'altezza del contenuto
 * sopra le slide dopo che initStackReveal ha già calcolato start/end del
 * ScrollTrigger: si ricalcolano (debounced) a ogni immagine caricata, così la
 * durata dello scrub resta allineata all'altezza reale del wrapper.
 */
var stackRevealRefreshTimer;
function refreshStackRevealSoon() {
    clearTimeout(stackRevealRefreshTimer);
    stackRevealRefreshTimer = setTimeout(function () {
        if (document.querySelector('[data-stack-reveal]')) {
            ScrollTrigger.refresh();
        }
    }, 150);
}
document.addEventListener('lazyloaded', refreshStackRevealSoon);
if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refreshStackRevealSoon);
}

/**
 * Ripulisce il pin/scroll-reveal a slide impilate prima che il container
 * venga sostituito da barba (v. transitions[].leave sotto), o quando si
 * scende sotto STACK_REVEAL_MIN_WIDTH (v. resize handler sotto): pulisce
 * anche il clip-path inline lasciato dal timeline, altrimenti le slide
 * resterebbero invisibili una volta tornate in flusso normale via CSS.
 */
function killStackReveal(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-stack-reveal]').forEach(function (root) {

        if (!root.__stackReveal) { return; }

        root.__stackReveal.kill();
        root.__stackReveal = null;

        gsap.set(root.querySelectorAll('[data-stack-slide]'), { clearProps: 'clipPath' });
    });
}

/**
 * Al resize, (ri)costruisce o rimuove il pin/scroll-reveal a slide impilate
 * a seconda che si sia sopra o sotto STACK_REVEAL_MIN_WIDTH (es.
 * rotazione di un tablet vicino al breakpoint md). Debounced, ed entrambe le
 * funzioni sono no-op se lo stato è già quello giusto.
 */
var stackRevealResizeTimer;
window.addEventListener('resize', function () {
    clearTimeout(stackRevealResizeTimer);
    stackRevealResizeTimer = setTimeout(function () {
        if (window.innerWidth >= STACK_REVEAL_MIN_WIDTH) {
            initStackReveal();
        } else {
            killStackReveal();
        }
    }, 200);
});

/**
 * Slider galleria immagini prodotto 
 */
function initGallerySlider(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-gallery-slider]').forEach(function (root) {

        // già inizializzato (es. elemento fuori dal container di barba)
        if (root.__gallerySlider) { return; }

        var el = root.querySelector('.swiper');
        if (!el) { return; }

        // pallini di paginazione, opzionali (v. [data-gallery-pagination] in livewire/materioteca-detail.blade.php)
        var paginationEl = root.querySelector('[data-gallery-pagination]');

        // una sola slide: niente swiper (né paginazione, né aree prev/next)
        if (el.querySelectorAll('.swiper-slide').length < 2) {
            if (paginationEl) { paginationEl.hidden = true; }
            return;
        }

        var slider = new Swiper(el, {
            slidesPerView: 1,
            speed: 800,
            loop: root.hasAttribute('data-gallery-loop'),
            pagination: paginationEl ? {
                el: paginationEl,
                clickable: true,
            } : false,
        });

        // se presenti testi per slide (v. sezione progetti in prodotti-dettaglio.blade.php),
        // mostra solo quello corrispondente alla slide attiva
        var textEls = root.querySelectorAll('[data-gallery-text]');
        if (textEls.length) {
            var showText = function (index) {
                textEls.forEach(function (textEl, i) {
                    textEl.hidden = i !== index;
                });
            };

            slider.on('slideChange', function () {
                showText(slider.realIndex);
            });
        }

        // slider di widget
        if (root.hasAttribute('data-widgets-slider')) {

            // su mobile l'altezza dello slider segue quella della slide attiva
            // (autoHeight di Swiper); da md in su resta l'altezza fissa
            var mqMobile = window.matchMedia('(max-width: 767px)');
            var setAutoHeight = function () {
                slider.params.autoHeight = mqMobile.matches;
                el.classList.toggle('swiper-autoheight', mqMobile.matches);
                if (mqMobile.matches) {
                    slider.updateAutoHeight();
                } else {
                    slider.wrapperEl.style.height = '';
                }
            };

            setAutoHeight();
            mqMobile.addEventListener('change', setAutoHeight);

            // immagini e video lazy cambiano l'altezza della slide quando caricano
            var onMediaLoad = function () {
                if (slider.params.autoHeight) { slider.updateAutoHeight(); }
            };
            el.addEventListener('load', onMediaLoad, true);
            el.addEventListener('loadedmetadata', onMediaLoad, true);
        }

        initGalleryHoverNav(root, slider);

        root.__gallerySlider = slider;
    });
}

/**
 * Aree prev/next di uno slider con l'icona che segue il mouse (classi
 * cursor-prev / cursor-next su .c-cursor, v. initSeguiMouse e .c-cursor in
 * main.scss) e cursor pointer. Niente elementi sovrapposti allo slider
 * (bloccherebbero drag, link, cta e pallini prodotto delle slide): l'area si
 * calcola dalla posizione del mouse su el. Solo mouse: su touch si usa lo swipe.
 * Il click lo gestisce chi la usa (v. initGalleryHoverNav, initParallaxSlider).
 *
 * options:
 * - edge: larghezza in px delle fasce prev/next ai lati; 0 = le due metà
 * - ignore: selettore di elementi sopra cui non c'è area (il click resta a loro)
 * - canPrev / canNext: funzioni, false = area non disponibile (es. prima/ultima slide)
 *
 * Restituisce { getSide(e), refresh(), destroy() }.
 */
function createHoverNav(el, options) {

    var edge = options.edge || 0;

    // area del mouse: 'prev', 'next' o null
    function getSide(e) {
        // su touch niente aree: senza icona il tap non deve cambiare slide
        if (e.pointerType && e.pointerType !== 'mouse') { return null; }
        if (window.matchMedia('(hover: none)').matches) { return null; }
        if (options.ignore && e.target.closest(options.ignore)) { return null; }

        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var side;

        if (edge) {
            if (x < edge) { side = 'prev'; }
            else if (x > rect.width - edge) { side = 'next'; }
            else { return null; }
        } else {
            side = x < rect.width / 2 ? 'prev' : 'next';
        }

        if (side === 'prev' && options.canPrev && !options.canPrev()) { return null; }
        if (side === 'next' && options.canNext && !options.canNext()) { return null; }

        return side;
    }

    function setCursor(side) {
        el.classList.toggle('cursor-pointer', !!side);

        if (!cursor) { return; }
        cursor.toggleClass('cursor-prev', side === 'prev');
        cursor.toggleClass('cursor-next', side === 'next');
    }

    var lastMove = null;

    // pointer events invece di mousemove: su touch il tap genera un mousemove
    // emulato che accenderebbe l'icona, qui si scartano i pointer non mouse
    function onMove(e) {
        if (e.pointerType !== 'mouse') { return; }
        lastMove = e;
        setCursor(getSide(e));
    }

    function onLeave() {
        lastMove = null;
        setCursor(null);
    }

    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerleave', onLeave);

    return {
        getSide: getSide,

        // ricalcola l'area col mouse fermo (es. a fine transizione)
        refresh: function () {
            if (lastMove) { setCursor(getSide(lastMove)); }
        },

        destroy: function () {
            el.removeEventListener('pointermove', onMove);
            el.removeEventListener('pointerleave', onLeave);
            onLeave();
        },
    };
}

/**
 * Aree prev/next degli slider swiper (v. createHoverNav): metà sinistra = prev,
 * metà destra = next. Il click arriva dall'evento 'click' di swiper, che non
 * scatta al termine di un trascinamento. Sopra link/bottoni l'area sparisce e
 * il click resta al link.
 * Con [data-gallery-hover-nav-edge="100"] sul root le aree sono solo due
 * fasce di 100px ai lati invece delle due metà 
 */
function initGalleryHoverNav(root, slider) {

    var hoverNav = createHoverNav(slider.el, {
        edge: parseInt(root.getAttribute('data-gallery-hover-nav-edge'), 10) || 0,
        ignore: 'a, button, input, select, textarea, label, [uk-tooltip]',
        canPrev: function () { return slider.params.loop || !slider.isBeginning; },
        canNext: function () { return slider.params.loop || !slider.isEnd; },
    });

    slider.on('click', function (swiper, e) {
        if (e.pointerType && e.pointerType !== 'mouse') { return; }

        var side = hoverNav.getSide(e);
        if (side === 'prev') { slider.slidePrev(); }
        if (side === 'next') { slider.slideNext(); }
    });

    // a fine transizione ricalcola l'area col mouse fermo
    // (es. arrivati all'ultima slide senza loop: niente più next)
    slider.on('slideChangeTransitionEnd', hoverNav.refresh);

    root.__galleryHoverNav = hoverNav;
}

/**
 * Distrugge le istanze di initGallerySlider() prima che il container
 * venga sostituito da barba (v. transitions[].leave sotto).
 */
function killGallerySlider(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-gallery-slider]').forEach(function (root) {

        if (!root.__gallerySlider) { return; }

        // listener di initGalleryHoverNav: vanno rimossi a mano, lo slider del
        // modal materioteca viene distrutto e ricreato sullo stesso elemento
        if (root.__galleryHoverNav) {
            root.__galleryHoverNav.destroy();
            root.__galleryHoverNav = null;
        }

        root.__gallerySlider.destroy(true, true);
        root.__gallerySlider = null;
    });
}

/**
 * Dichiarazione cookie di Cookiebot (pagina cookies).
 * Lo script cd.js renderizza la tabella subito dopo il tag con
 * id "CookieDeclaration": lo inietto qui perché gli script inline
 * nei container barba non vengono eseguiti.
 */
function initCookieDeclaration(container) {

    var scope = container || document;
    var target = scope.querySelector('[data-cookie-declaration]');
    if (!target || target.querySelector('#CookieDeclaration')) { return; }

    var script = document.createElement('script');
    script.id = 'CookieDeclaration';
    script.async = true;
    script.src = 'https://consent.cookiebot.com/' + target.dataset.cookieDeclaration + '/cd.js';
    script.setAttribute('data-culture', document.documentElement.lang || 'it');
    target.appendChild(script);
}

/**
 * Modal dettaglio materiale (v. [data-materiale-modal] in
 * livewire/materioteca-detail.blade.php, componente MateriotecaDetail).
 * Contenuto e visibilità (classe hidden, attributo data-aperto) li decide il
 * componente Livewire: il click su un'anteprima lo apre con l'evento
 * materioteca-dettaglio, la chiusura (X, backdrop, Esc) fa sparire il modal
 * in dissolvenza e poi svuota il record lato server (query string senza
 * "dettaglio"). L'apertura entra in dissolvenza.
 * Qui si sincronizzano body overflow e gallery dopo ogni render del
 * componente: la gallery riusa initGallerySlider/killGallerySlider, distrutta
 * prima del morph e ricreata dopo (Swiper calcolerebbe male le larghezze
 * delle slide con il modal display:none).
 */
function initMaterialeModal(container) {

    var scope = container || document;
    var modal = scope.querySelector('[data-materiale-modal]');
    if (!modal || modal.__materialeModal) { return; }

    var wireId = modal.getAttribute('wire:id');

    // stato al render precedente: il fade-in parte solo nel passaggio da
    // chiuso ad aperto, non a ogni render con il modal già aperto
    var wasOpen = false;

    // fade-out di chiusura in corso (v. close)
    var closing = false;

    function sync() {
        var aperto = !modal.classList.contains('hidden');

        // riaperto (es. click su un'altra anteprima) durante il fade-out:
        // si interrompe la chiusura e il modal resta visibile
        if (aperto && closing) {
            closing = false;
            gsap.killTweensOf(modal);
            gsap.set(modal, {clearProps: 'opacity'});
        }

        document.body.style.overflow = aperto ? 'hidden' : '';
        if (aperto) { initGallerySlider(modal); }
        if (aperto && !wasOpen) {
            gsap.fromTo(modal, {opacity: 0}, {opacity: 1, duration: 0.4, ease: 'power1.out', clearProps: 'opacity'});
        }
        wasOpen = aperto;
    }

    function hide() {
        gsap.killTweensOf(modal);
        gsap.set(modal, {clearProps: 'opacity'});
        wasOpen = false;
        closing = false;
        modal.classList.add('hidden');
        document.body.style.overflow = '';
        killGallerySlider(modal);
    }

    // il record si svuota lato server solo a fade-out finito: la risposta
    // Livewire rimuoverebbe il contenuto mentre sta ancora sfumando
    function close() {
        if (modal.classList.contains('hidden') || closing) { return; }
        closing = true;
        gsap.to(modal, {opacity: 0, duration: 0.3, ease: 'power1.in', onComplete: function () {
            hide();
            Livewire.find(wireId).close();
        }});
    }

    function onKeydown(e) {
        if (e.key === 'Escape') { close(); }
    }

    // delegato: i bottoni di chiusura vengono ricreati a ogni render del componente
    modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-materiale-modal-close]')) { close(); }
    });

    document.addEventListener('keydown', onKeydown);

    var offHooks = [];

    offHooks.push(Livewire.hook('morph', function (args) {
        if (args.el === modal) { killGallerySlider(modal); }
    }));
    offHooks.push(Livewire.hook('morphed', function (args) {
        if (args.el === modal) { sync(); }
    }));

    // aperto all'atterraggio da deep link
    sync();

    modal.__materialeModal = { hide: hide, onKeydown: onKeydown, offHooks: offHooks };
}

/**
 * Nasconde il modal dettaglio materiale e rimuove il listener keydown globale
 * e gli hook Livewire prima che il container venga sostituito da barba (v.
 * transitions[].leave sotto). Solo lato client: lo stato del componente
 * sparisce con la pagina. I listener sul modal non vanno rimossi a mano:
 * spariscono insieme al DOM quando barba lo sostituisce.
 */
function killMaterialeModal(container) {

    var scope = container || document;
    var modal = scope.querySelector('[data-materiale-modal]');
    if (!modal || !modal.__materialeModal) { return; }

    modal.__materialeModal.hide();
    document.removeEventListener('keydown', modal.__materialeModal.onKeydown);
    modal.__materialeModal.offHooks.forEach(function (off) { off(); });
    modal.__materialeModal = null;
}

/**
 * Tab prodotti correlati / stessa collezione (v. [data-prodotti-tabs],
 * [data-tab-btn] e [data-tab-panel] in prodotti-dettaglio.blade.php): un
 * pannello visibile alla volta. Allo switch forza il resize dello slider
 * parallax del pannello mostrato, perché Smooothy calcola male le larghezze
 * delle slide se inizializzato mentre il pannello è display:none.
 */
function initProdottiTabs(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-prodotti-tabs]').forEach(function (root) {

        if (root.__prodottiTabs) { return; }

        var btns = root.querySelectorAll('[data-tab-btn]');
        var panels = root.querySelectorAll('[data-tab-panel]');
        if (!btns.length || !panels.length) { return; }

        btns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();

                var tab = btn.getAttribute('data-tab-btn');

                btns.forEach(function (b) {
                    b.classList.toggle('opacity-30', b !== btn);
                });

                panels.forEach(function (panel) {
                    var active = panel.getAttribute('data-tab-panel') === tab;
                    panel.hidden = !active;

                    if (active) {
                        var sliderRoot = panel.querySelector('[data-parallax-init]');
                        if (sliderRoot && sliderRoot.__parallaxSlider) {
                            sliderRoot.__parallaxSlider.resize();
                        }
                    }
                });
            });
        });

        root.__prodottiTabs = true;
    });
}


/**
 * Pulsante "torna ai prodotti" del dettaglio prodotto (v. [data-torna-lista]
 * in prodotti-dettaglio.blade.php).
 * Uscendo da una lista prodotti (categoria/ricerca, filtri compresi nell'url)
 * ne vengono memorizzati in sessionStorage url e posizione di scroll; le
 * pagine prodotto non li sovrascrivono, quindi anche passando da un
 * correlato all'altro il pulsante riporta alla lista di partenza. Entrando in
 * una pagina che non è né lista né prodotto la lista memorizzata viene
 * dimenticata. Senza lista memorizzata il pulsante mantiene il link di
 * fallback impostato nel blade (collezione/categoria del prodotto).
 * Tornando alla lista dal pulsante o dal "indietro" del browser viene
 * ripristinata la posizione di scroll (v. restoreListaProdottiScroll).
 */
var LISTA_PRODOTTI_STORAGE_KEY = 'listaProdottiProvenienza';
var LISTA_PRODOTTI_NAMESPACES = ['prodotti-categoria'];

function urlSenzaHash(href) {
    var url = new URL(href, window.location.href);
    return url.origin + url.pathname + url.search;
}

function getListaProdotti() {
    try {
        var lista = JSON.parse(sessionStorage.getItem(LISTA_PRODOTTI_STORAGE_KEY));
        return lista && lista.url ? lista : null;
    } catch (e) {
        return null;
    }
}

function saveListaProdotti(href) {
    try {
        sessionStorage.setItem(LISTA_PRODOTTI_STORAGE_KEY, JSON.stringify({
            url: urlSenzaHash(href),
            scroll: window.scrollY,
        }));
    } catch (e) {}
}

function clearListaProdotti() {
    try {
        sessionStorage.removeItem(LISTA_PRODOTTI_STORAGE_KEY);
    } catch (e) {}
}

function initTornaLista(container) {

    var scope = container || document;
    var link = scope.querySelector('[data-torna-lista] a');
    var lista = getListaProdotti();
    if (!link || !lista) { return; }

    link.setAttribute('href', lista.url);
}

/**
 * Aggiornamento della lista memorizzata ad ogni cambio pagina (v. hook di
 * barba): salva la lista che si sta lasciando, dimentica quella memorizzata
 * se si entra in una pagina estranea, e prepara il ripristino dello scroll
 * (letto da restoreListaProdottiScroll in pageEnter).
 */
// in beforeLeave barba ha già aggiornato window.location con l'url di
// destinazione, e data.current.url è quello di quando la pagina è entrata
// (senza i filtri cambiati poi da Livewire con pushState): l'url della lista
// viene quindi letto al click, in capture prima del listener di barba
var listaProdottiClickHref = null;
window.addEventListener('click', function () {
    listaProdottiClickHref = window.location.href;
}, true);

function onListaProdottiLeave(data) {
    if (LISTA_PRODOTTI_NAMESPACES.indexOf(data.current.namespace) === -1) { return; }

    var fromClick = data.trigger instanceof Element && listaProdottiClickHref;
    saveListaProdotti(fromClick ? listaProdottiClickHref : data.current.url.href);
}

function onListaProdottiEnter(data) {

    window.__listaProdottiScroll = null;

    var namespace = data.next.namespace;
    if (LISTA_PRODOTTI_NAMESPACES.indexOf(namespace) === -1) {
        if (namespace !== 'prodotti-dettaglio') {
            clearListaProdotti();
        }
        return;
    }

    var lista = getListaProdotti();
    var fromButton = data.trigger instanceof Element && !!data.trigger.closest('[data-torna-lista]');
    var fromHistory = data.trigger === 'back' || data.trigger === 'popstate';

    if (lista && (fromButton || fromHistory) && lista.url === urlSenzaHash(window.location.href)) {
        window.__listaProdottiScroll = lista.scroll;
    }
}

/**
 * Immagine ambientata di rollover delle anteprime prodotto in griglia (v.
 * [data-anteprima] e [data-rollover] in x-prodotti.anteprima): è senza classe
 * lazyload, quindi lazysizes non la scarica all'ingresso nel viewport (è a
 * opacity 0); viene caricata al primo hover. Solo con puntatore preciso: su
 * touch il rollover non c'è e l'immagine non viene mai caricata.
 * Listener delegato sul document: vale anche per i contenuti caricati da
 * barba e riscritti da Livewire.
 */
document.addEventListener('mouseover', function (e) {

    if (!window.matchMedia('(pointer: fine)').matches) { return; }

    var anteprima = e.target.closest && e.target.closest('[data-anteprima]');
    if (!anteprima) { return; }

    anteprima.querySelectorAll('img[data-rollover]:not(.lazyloading):not(.lazyloaded)').forEach(function (img) {
        lazySizes.loader.unveil(img);
    });
});

function restoreListaProdottiScroll() {

    var y = window.__listaProdottiScroll;
    window.__listaProdottiScroll = null;
    if (typeof y !== 'number' || !y) { return; }

    if (locomotiveScroll) {
        // aggiorna le dimensioni (il nuovo container è appena stato inserito da barba).
        // locomotiveScroll.resize() non ricalcola quelle di Lenis, aggiornate da solo
        // con 250ms di debounce: scrollTo verrebbe limitato all'altezza della pagina
        // precedente (es. lista lunga lasciata dal fondo, scroll fermo a metà)
        locomotiveScroll.lenisInstance.resize();
        locomotiveScroll.resize();
        locomotiveScroll.scrollTo(y, {immediate: true});
    } else {
        window.scrollTo({top: y, behavior: 'instant'});
    }
}


/**
 * Toggle della colonna filtri
 * La scelta viene ricordata in sessionStorage e riapplicata su tutte le pagine di questo tipo.
 */
var FILTRI_TOGGLE_STORAGE_KEY = 'filtriCategoriaNascosti';

function initFiltriToggle(container) {

    var scope = container || document;
    var wrapper = scope.querySelector('[data-filtri-toggle-wrapper]');
    if (!wrapper) { return; }

    var btn = wrapper.querySelector('[data-filtri-toggle-btn]');
    var icon = wrapper.querySelector('[data-filtri-toggle-icon]');
    var filtriCol = wrapper.querySelector('[data-filtri-col]');
    var filtriContent = wrapper.querySelector('[data-filtri-content]');
    var prodottiCol = wrapper.querySelector('[data-prodotti-col]');
    if (!btn || !icon || !filtriCol || !filtriContent || !prodottiCol) { return; }
   
    // larghezza fissa del contenuto (non si riflette mentre la colonna si anima):
    // 20% dell'area interna del wrapper, come la colonna aperta. Non si misura la
    // colonna perché può essere nascosta (es. ricerca senza risultati) e varrebbe 0
    if (window.matchMedia('(min-width: 1200px)').matches) {
        var wrapperStyle = getComputedStyle(wrapper);
        var wrapperInnerWidth = wrapper.clientWidth - parseFloat(wrapperStyle.paddingLeft) - parseFloat(wrapperStyle.paddingRight);
        filtriContent.style.width = (wrapperInnerWidth * 0.2) + 'px';
    }

    function applyState(hidden, animate) {

        icon.classList.toggle('rotate-180', !hidden);

        // sotto md i filtri sono sempre visibili, colonne impilate: niente override di larghezza
        if (!window.matchMedia('(min-width: 1200px)').matches) {
            gsap.set([filtriCol, prodottiCol], { clearProps: 'width' });
            return;
        }

        if (!animate) {
            gsap.set(filtriCol, { width: hidden ? '0%' : '20%' });
            gsap.set(prodottiCol, { width: hidden ? '100%' : '80%' });
            return;
        }

        gsap.to(filtriCol, { width: hidden ? '0%' : '20%', duration: 0.6, ease: 'power2.inOut' });
        gsap.to(prodottiCol, { width: hidden ? '100%' : '80%', duration: 0.6, ease: 'power2.inOut' });
    }

    // dentro [data-filtri-nascosti] (es. risultati di ricerca) i filtri partono
    // nascosti e la scelta non viene letta né salvata in sessionStorage
    var fixedDefault = !!wrapper.closest('[data-filtri-nascosti]');

    var hidden = fixedDefault || sessionStorage.getItem(FILTRI_TOGGLE_STORAGE_KEY) === '1';
    applyState(hidden, false);

    btn.addEventListener('click', function () {
        hidden = !hidden;
        if (!fixedDefault) {
            sessionStorage.setItem(FILTRI_TOGGLE_STORAGE_KEY, hidden ? '1' : '0');
        }
        applyState(hidden, true);
    });
}

/**
 * Toggle vista big/small della griglia prodotti (v. [data-vista-btn] e
 * [data-prodotti-grid] in prodotti-categoria.blade.php e materioteca.blade.php):
 * "small" (default) è la griglia più fitta, "big" mostra elementi più grandi.
 * Le classi di colonne per i due stati sono lette da [data-prodotti-grid]
 * (attributi data-vista-grid-small/-big, v. blade), per poter riusare lo
 * stesso script su griglie con breakpoint diversi. Se assenti si usa il
 * default di prodotti-categoria.blade.php. La scelta viene ricordata in
 * sessionStorage e riapplicata su tutte le pagine di questo tipo.
 */
var VISTA_TOGGLE_STORAGE_KEY = 'vistaProdottiCategoria';
var VISTA_GRID_CLASSES_DEFAULT = {
    small: ['lg:grid-cols-3', 'xl:grid-cols-4'],
    big: ['lg:grid-cols-2', 'xl:grid-cols-3'],
};

function initVistaToggle(container) {

    var scope = container || document;
    var grid = scope.querySelector('[data-prodotti-grid]');
    var btnBig = scope.querySelector('[data-vista-btn="big"]');
    var btnSmall = scope.querySelector('[data-vista-btn="small"]');
    if (!grid || !btnBig || !btnSmall) { return; }

    var iconBig = btnBig.querySelector('img');
    var iconSmall = btnSmall.querySelector('img');

    var gridClasses = {
        small: grid.dataset.vistaGridSmall ? grid.dataset.vistaGridSmall.split(' ') : VISTA_GRID_CLASSES_DEFAULT.small,
        big: grid.dataset.vistaGridBig ? grid.dataset.vistaGridBig.split(' ') : VISTA_GRID_CLASSES_DEFAULT.big,
    };

    function applyState(vista, animate) {

        // FLIP: cattura la posizione/dimensione attuale di ogni prodotto
        // prima del cambio di layout, per poterle animare verso quelle nuove
        var state = animate ? Flip.getState(grid.children) : null;

        grid.classList.remove.apply(grid.classList, gridClasses.small.concat(gridClasses.big));
        grid.classList.add.apply(grid.classList, gridClasses[vista]);

        iconBig.classList.toggle('opacity-40', vista !== 'big');
        iconSmall.classList.toggle('opacity-40', vista !== 'small');

        if (state) {
            // niente absolute:true: toglierebbe i <li> dal flusso durante
            // l'animazione, facendo collassare l'altezza di <ul> (e apparire
            // il footer sotto) fino al termine del tween
            Flip.from(state, { duration: 0.6, ease: 'power2.inOut' });
        }
    }

    var vista = sessionStorage.getItem(VISTA_TOGGLE_STORAGE_KEY) === 'big' ? 'big' : 'small';
    applyState(vista, false);

    btnBig.addEventListener('click', function (e) {
        e.preventDefault();
        vista = 'big';
        sessionStorage.setItem(VISTA_TOGGLE_STORAGE_KEY, vista);
        applyState(vista, true);
    });

    btnSmall.addEventListener('click', function (e) {
        e.preventDefault();
        vista = 'small';
        sessionStorage.setItem(VISTA_TOGGLE_STORAGE_KEY, vista);
        applyState(vista, true);
    });
}


/**
 * Toggle "vedi tutti / vedi meno" della griglia moduli in
 * prodotti-dettaglio.blade.php (v. [data-moduli-wrapper], [data-moduli-grid],
 * [data-moduli-toggle]): la griglia parte limitata a 2 righe (in base al
 * numero di colonne del breakpoint attivo) e i due pulsanti la espandono
 * o la ricollassano.
 */
var MODULI_COLLAPSED_ROWS = 2;

function initModuliToggle(container) {

    var scope = container || document;
    var wrapper = scope.querySelector('[data-moduli-wrapper]');
    if (!wrapper) { return; }

    var grid = wrapper.querySelector('[data-moduli-grid]');
    var btnTutti = wrapper.querySelector('[data-moduli-toggle="tutti"]');
    var btnMeno = wrapper.querySelector('[data-moduli-toggle="meno"]');
    if (!grid || !btnTutti || !btnMeno) { return; }

    var items = grid.children;
    var expanded = false;

    // altezza (in px) delle prime MODULI_COLLAPSED_ROWS righe, in base al
    // numero di colonne effettivo del breakpoint attivo; null se il totale
    // dei moduli entra già in quelle righe (niente da nascondere)
    function getCollapsedHeight() {

        var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
        var cutoff = cols * MODULI_COLLAPSED_ROWS;

        if (items.length <= cutoff) { return null; }

        var lastVisible = items[cutoff - 1];
        return lastVisible.getBoundingClientRect().bottom - grid.getBoundingClientRect().top;
    }

    function applyState(animate) {

        var collapsedHeight = getCollapsedHeight();

        if (collapsedHeight === null) {
            gsap.set(grid, { clearProps: 'height,overflow' });
            btnTutti.hidden = true;
            btnMeno.hidden = true;
            return;
        }

        var targetHeight = expanded ? grid.scrollHeight : collapsedHeight;

        if (animate) {
            gsap.to(grid, { height: targetHeight, overflow: 'hidden', duration: 0.6, ease: 'power2.inOut' });
        } else {
            gsap.set(grid, { height: targetHeight, overflow: 'hidden' });
        }

        btnTutti.hidden = expanded;
        btnMeno.hidden = !expanded;
    }

    applyState(false);

    btnTutti.addEventListener('click', function (e) {
        e.preventDefault();
        expanded = true;
        applyState(true);
    });

    btnMeno.addEventListener('click', function (e) {
        e.preventDefault();
        expanded = false;
        applyState(true);

        if (locomotiveScroll) {
            locomotiveScroll.scrollTo(wrapper, { offset: -100 });
        } else {
            var top = wrapper.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: top, behavior: 'smooth' });
        }
    });
}


/**
 * Ripulisce le istanze di initParallaxSlider() prima che il container
 * venga sostituito da barba (v. transitions[].leave sotto).
 */
function killParallaxSlider(container) {

    var scope = container || document;

    scope.querySelectorAll('[data-parallax-init]').forEach(function (root) {

        if (!root.__parallaxSlider) { return; }

        gsap.ticker.remove(root.__parallaxSliderTick);
        root.__parallaxSlider.destroy();
        if (root.__parallaxSliderCleanup) { root.__parallaxSliderCleanup(); }
        root.__parallaxSlider = null;
        root.__parallaxSliderTick = null;
        root.__parallaxSliderCleanup = null;
    });
}


/**
 * Destinazione di scroll per un'ancora. Su desktop le slide di [data-stack-reveal]
 * sono impilate in absolute dentro una ul sticky, quindi tutte occupano la stessa
 * posizione e scrollare all'elemento porta sempre alla prima. La slide i è svelata
 * del tutto dopo i * 100dvh di scroll dall'inizio del wrapper: restituisce
 * quella posizione (numero). Altrimenti restituisce l'elemento stesso.
 */
function getAnchorScrollTarget(el)
{
    const slide = el.closest('[data-stack-slide]');
    const root = slide && slide.closest('[data-stack-reveal]');
    if (!root || window.innerWidth < STACK_REVEAL_MIN_WIDTH) {
        return el;
    }

    const index = Array.from(root.querySelectorAll('[data-stack-slide]')).indexOf(slide);
    return root.getBoundingClientRect().top + window.pageYOffset + index * window.innerHeight;
}


/**
 * Se l'url contiene un #hash che corrisponde a un elemento della pagina
 * (es. /download#risorse), scrolla immediatamente a quell'elemento.
 * Usa data-anchor-offset dell'elemento, se presente.
 */
function scrollToHash(hashName)
{
    // barba, dopo la richiesta ajax, riscrive l'url con quello di risposta
    // (privo di #hash): l'hash va quindi passato esplicitamente (data.next.url.hash)
    const hash = hashName ? '#' + hashName : window.location.hash;
    if (!hash || hash.length < 2) {
        return;
    }

    // ripristina l'hash eventualmente perso nell'url
    if (window.location.hash !== hash) {
        window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search + hash);
    }

    let el = null;
    try {
        el = document.querySelector(decodeURIComponent(hash));
    } catch (e) {
        return;
    }
    if (!el) {
        return;
    }

    const offset = parseInt(el.getAttribute('data-anchor-offset')) || 0;

    if (locomotiveScroll) {
        // aggiorna le dimensioni (il nuovo container è appena stato inserito da barba)
        locomotiveScroll.resize();
        locomotiveScroll.scrollTo(getAnchorScrollTarget(el), {offset: -offset, immediate: true});
    } else {
        const target = getAnchorScrollTarget(el);
        const top = (typeof target === 'number' ? target : target.getBoundingClientRect().top + window.pageYOffset) - offset;
        window.scrollTo({top, behavior: 'instant'});
    }
}


/**
 * Risolta quando il loading del primo caricamento è sparito (fine del primo
 * pageEnter): le animazioni d'ingresso (es. intro della home) partono dopo,
 * così non vanno in scena sotto il loader. Nei cambi pagina è già risolta.
 */
var resolveSiteLoaderDone;
var siteLoaderDone = new Promise(function (resolve) { resolveSiteLoaderDone = resolve; });


/**
 * Funzione di entrata pagina
 */
function pageEnter(callback, hash, container){

    setTimeout(function() {

        // scroll all'eventuale #ancora dell'url (prima che il loader esca)
        scrollToHash(hash);

        // ritorno a una lista prodotti: scroll alla posizione lasciata (v. onListaProdottiEnter)
        restoreListaProdottiScroll();

        var loader = document.getElementById('page_loader');

        function onLoaderHidden() {

            // Animation complete
            updateSeguiMouse();

            // rivelazione testo parola per parola on-scroll (v. x-text-reveal)
            initTextReveal();

            // fade di opacity on-scroll (v. [data-scroll-opacity])
            initScrollOpacity();

            // intro a due colonne con immagine sticky (v. about.blade.php)
            initSplitResize();

            // slider drag/parallax (v. section.progetti)
            initParallaxSlider();

            // pin/scroll-reveal delle collezioni (v. prodotti-collezioni-outdoor.blade.php)
            initStackReveal();

            //anchor link
            document.querySelectorAll('a[href^="#"].c-anchor').forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    const target = this.getAttribute('href');
                    const offset = parseInt(this.getAttribute('data-anchor-offset')) || 0;
                    const el = document.querySelector(target);
                    if (!el) {
                        return;
                    }
                    const dest = getAnchorScrollTarget(el);
                    if (locomotiveScroll) {
                        locomotiveScroll.scrollTo(dest, {offset: -offset});
                    } else {
                        const top = (typeof dest === 'number' ? dest : dest.getBoundingClientRect().top + window.pageYOffset) - offset;
                        window.scrollTo({top, behavior: 'smooth'});
                    }
                });
            })

            // porto sotto per poter interagire con pagina
            gsap.set(loader, {
                zIndex: -1,
                opacity: 0,
                clearProps: 'clipPath'
            });

            // il loading del primo caricamento non serve più: da qui in poi
            // #page_loader è solo il velo bianco dei cambi pagina
            $("[data-site-loader]").remove();
            resolveSiteLoaderDone();
            if (callback && typeof(callback) == 'function') {
                callback();
            }
        }

        gsap.killTweensOf(loader);

        // in una pagina di errore viene stampato l'attributo "data-page-loader-hidden".
        // lo rimuovo e richiamo la funzione per reinizializzarlo, in modo che
        // funzioni per l'uscita dalla pagina di errore
        if (loader.hasAttribute('data-page-loader-hidden')) {
            loader.removeAttribute('data-page-loader-hidden');
            onLoaderHidden();
            return;
        }

        // primo caricamento: il loading con la percentuale si dissolve
        if (loader.querySelector('[data-site-loader]')) {
            gsap.to(loader, {opacity: 0, duration: 1, ease: 'power1.inOut', onComplete: onLoaderHidden});
            return;
        }

        // cambio pagina: la nuova pagina sale da sotto mentre la tendina esce
        // verso l'alto e la scopre. Lo spostamento parte solo qui, dopo
        // scrollToHash(), che altrimenti misurerebbe le posizioni già traslate
        var shift = container && pageShiftEnabled();

        // header nascosto nella pagina precedente: rientra adesso, appena prima
        // che la nuova pagina compaia (v. revealHeaderForPageChange)
        revealHeaderForPageChange();

        if (shift) {
            gsap.fromTo(container, {y: PAGE_SHIFT}, {
                y: 0,
                duration: PAGE_CURTAIN_ENTER_DURATION,
                ease: PAGE_CURTAIN_EASE
            });
        }

        gsap.to(loader, {
            clipPath: 'inset(0% 0% 100% 0%)',
            duration: PAGE_CURTAIN_ENTER_DURATION,
            ease: PAGE_CURTAIN_EASE,
            onUpdate: function() {
                // quando il bordo inferiore della tendina arriva quasi all'header, questo
                // passa dal positivo del cambio pagina al colore della nuova pagina
                // (v. lockHeaderModePositive); dopo il primo sblocco è un no-op
                if (this.ratio >= PAGE_CURTAIN_HEADER_UNLOCK) {
                    unlockHeaderMode();
                }
            },
            onComplete: function() {
                unlockHeaderMode();

                // via il transform dal container: altrimenti fa da riferimento per
                // i figli fixed/sticky; poi locomotive ricalcola le metriche, prese
                // in afterEnter con la pagina ancora traslata
                if (shift) {
                    gsap.set(container, {clearProps: 'transform'});
                    if (locomotiveScroll) {
                        locomotiveScroll.resize();
                    }
                }

                onLoaderHidden();
            }
        });

    }, 120);

}


/**
 * Inizializza Locomotive Scroll (smooth scroll su Lenis) e lo espone su
 * window.locomotiveScroll. Il callback di scroll tiene sincronizzato GSAP
 * ScrollTrigger e aggiorna la visibilità dell'header ad ogni frame.
 *
 * Se l'utente ha impostato "riduci animazioni" a livello di sistema,
 * Locomotive non viene istanziato affatto: si torna allo scroll nativo del
 * browser (niente smoothing, niente parallax data-scroll-speed). ScrollTrigger
 * funziona comunque di default sullo scroll nativo della window.
 */
function locomotiveScrollInit(){

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.locomotiveScroll = null;
        window.addEventListener('scroll', onPageScroll);
        window.addEventListener('resize', updateHeaderScroll);
        updateHeaderColor();
        onPageScroll();
        return;
    }

    const locomotiveScroll = new LocomotiveScroll({
        lenisOptions: {
            duration: 1.2,
            easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
            orientation: "vertical",
            gestureOrientation: "vertical",
            touchMultiplier: 2,
        },
        scrollCallback: (e) => {

            // tiene sincronizzato GSAP ScrollTrigger con lo scroll smoothato di locomotive-scroll/Lenis
            ScrollTrigger.update();

            // la classe menuOpen sul body è gestita solo da Alpine (x-effect
            // in base.blade.php): toglierla qui lascerebbe il pannello aperto
            // con l'header nei colori della section sottostante

            onPageScroll();
        }
    });

    window.locomotiveScroll = locomotiveScroll;
    window.addEventListener('resize', updateHeaderScroll);

    // se il menu è stato aperto prima dell'init, Lenis parte già fermo
    if (pageScrollLocked) {
        locomotiveScroll.stop();
    }

    // stato iniziale (prima di qualsiasi scroll)
    updateHeaderColor();
    onPageScroll();
}


/**
 * Aggiornamenti legati alla posizione di scroll: visibilità dell'header,
 * nav fixed in basso del dettaglio prodotto.
 */
function onPageScroll() {
    updateHeaderScroll();
    updateFixedBottomNavVisibility();
}


/**
 * L'header (fixed) scorre via insieme alla pagina, seguendo lo scroll
 * finché non è uscito del tutto; poi resta nascosto (headerScrolled).
 * Accennando lo scroll verso l'alto rientra dall'alto in positivo con
 * sfondo bianco (headerRevealed, v. main.scss) e si nasconde di nuovo
 * scrollando in giù; tornati sopra il punto di partenza riprende l'aspetto
 * normale.
 * Da md in su, se la prima section della pagina ha data-header-fixed
 * (es. hero a tutto schermo), l'header resta fisso finché quella section
 * non è uscita dall'alto, e solo da lì comincia a scorrere via (v.
 * getHeaderScrollStart).
 * Con il menu aperto lo scroll è bloccato e l'header resta in vista.
 */
var HEADER_REVEAL_DISTANCE = 10; // px di scroll verso l'alto per farlo riapparire
var headerScrollLastY = 0;
var headerScrollUpDistance = 0;
var headerScrollFrozen = false;

function updateHeaderScroll() {

    var header = document.querySelector('.c-header');
    if (!header) { return; }

    var body = document.body;
    var y = Math.max(0, window.scrollY);
    var delta = y - headerScrollLastY;
    headerScrollLastY = y;

    // a menu aperto lo stato resta congelato (l'header è comunque in vista),
    // così come durante il cambio pagina (v. revealHeaderForPageChange)
    if (pageScrollLocked || headerScrollFrozen) { return; }

    // durante uno scroll programmatico verso l'alto non si accumula (v. suppressHeaderReveal)
    headerScrollUpDistance = delta < 0 && !headerRevealSuppressed ? headerScrollUpDistance - delta : 0;

    // px di scroll oltre il punto da cui l'header comincia a scorrere via
    var height = header.offsetHeight;

    // altezza dell'header per gli elementi sticky che scendono sotto di lui quando riappare (es. .c-sticky-nav)
    document.documentElement.style.setProperty('--header-h', height + 'px');
    var past = y - getHeaderScrollStart(y, height);
    var revealed = body.classList.contains('headerRevealed');

    if (past <= 0) {
        revealed = false;
    } else if (revealed && delta > 0) {
        revealed = false;
    } else if (!revealed && past > height && headerScrollUpDistance >= HEADER_REVEAL_DISTANCE) {
        revealed = true;
        // riapparso con lo scroll: di nuovo con l'ombra (v. revealHeaderForPageChange)
        body.classList.remove('headerNoShadow');
    }

    body.classList.toggle('headerRevealed', revealed);
    body.classList.toggle('headerScrolled', !revealed && past > height);

    // appena superato il punto di partenza l'header segue lo scroll, senza transizione
    header.style.transform = (!revealed && past > 0 && past <= height) ? 'translateY(' + (-past) + 'px)' : '';
}


/**
 * Durante uno scroll programmatico verso l'alto (es. click sulla nav della
 * materioteca) l'header non deve riapparire: se era in vista viene nascosto e,
 * finché dura lo scroll, lo scroll verso l'alto non viene accumulato (v.
 * updateHeaderScroll). Si rilascia a fine scroll (onComplete di locomotive) o,
 * se non arriva (es. scroll interrotto dall'utente), dopo HEADER_REVEAL_SUPPRESS_MAX.
 */
var HEADER_REVEAL_SUPPRESS_MAX = 2000; // ms, oltre la durata dello scroll di locomotive
var headerRevealSuppressed = false;
var headerRevealSuppressTimer = null;

function suppressHeaderReveal() {

    headerRevealSuppressed = true;
    headerScrollUpDistance = 0;
    document.body.classList.remove('headerRevealed');
    updateHeaderScroll();

    clearTimeout(headerRevealSuppressTimer);
    headerRevealSuppressTimer = setTimeout(releaseHeaderReveal, HEADER_REVEAL_SUPPRESS_MAX);
}

function releaseHeaderReveal() {

    clearTimeout(headerRevealSuppressTimer);
    headerRevealSuppressed = false;
}


/**
 * Scroll (px) da cui l'header comincia a scorrere via: 0 di default,
 * oppure, da md in su, se la prima section della pagina ha
 * data-header-fixed, il punto in cui la section successiva arriva al bordo
 * inferiore dell'header: da lì l'header esce spinto in su insieme a lei.
 * Il bordo della section è misurato a ogni chiamata (le altezze cambiano
 * con il caricamento di immagini e font).
 */
function getHeaderScrollStart(y, headerHeight) {

    if (window.innerWidth < 768) { return 0; }

    var section = getFirstSection();
    if (!section || !section.hasAttribute('data-header-fixed')) { return 0; }

    return Math.max(0, section.getBoundingClientRect().bottom + y - headerHeight);
}


/**
 * Al cambio pagina l'header, se nascosto o uscito a metà, resta così
 * mentre il velo copre la pagina (headerScrollFrozen, impostato in
 * beforeLeave: lo scroll a 0 non lo modifica) e rientra appena prima che
 * compaia la nuova pagina (v. pageEnter), con la stessa animazione di
 * quando si accenna lo scroll verso l'alto (headerRevealed), invece di
 * ricomparire di colpo, ma senza ombra (headerNoShadow, tolta alla prossima
 * riapparizione con lo scroll, così non ricompare mentre il fondo sfuma).
 * Torna al comportamento normale allo sblocco (v. unlockHeaderMode).
 */
function revealHeaderForPageChange() {

    var header = document.querySelector('.c-header');
    var body = document.body;

    if (header && (body.classList.contains('headerScrolled') || header.style.transform)) {
        body.classList.remove('headerScrolled');
        body.classList.add('headerRevealed', 'headerNoShadow');
        header.style.transform = '';
    }
}


/**
 * Blocca/sblocca lo scroll della pagina (es. con il menu aperto) senza
 * toccare l'overflow di html/body: la barra di scroll resta visibile e il
 * layout non si sposta.
 *
 * Con Locomotive/Lenis basta fermarlo: da fermo annulla wheel e touch.
 * Senza Lenis (prefers-reduced-motion) gli stessi eventi vengono annullati
 * a mano. In entrambi i casi le aree scrollabili interne marcate con
 * [data-lenis-prevent] continuano a scorrere.
 */
var pageScrollLocked = false;

function preventPageScroll(e) {
    if (e.target.closest && e.target.closest('[data-lenis-prevent]')) { return; }
    if (e.cancelable) { e.preventDefault(); }
}

function setPageScrollLock(locked) {

    locked = !!locked;
    if (locked === pageScrollLocked) { return; }
    pageScrollLocked = locked;

    if (!locked) {
        window.removeEventListener('wheel', preventPageScroll);
        window.removeEventListener('touchmove', preventPageScroll);
    }

    if (window.locomotiveScroll) {
        locked ? window.locomotiveScroll.stop() : window.locomotiveScroll.start();
        return;
    }

    if (locked) {
        window.addEventListener('wheel', preventPageScroll, { passive: false });
        window.addEventListener('touchmove', preventPageScroll, { passive: false });
    }
}
window.setPageScrollLock = setPageScrollLock;


// timeline dell'intro in corso (v. initIntroAnimation / killIntroAnimation)
var introTimeline = null;

/**
 * Riproduce l'animazione dell'intro (c-panel) al caricamento della pagina:
 * ingresso di titoli, riquadro video e testo, poi video e testo bianco si
 * espandono dallo slot fino a schermo intero, senza legami con lo scroll. A fine animazione si passa allo stato .is-revealed
 * (v. showIntroRevealed), così il layout resta corretto anche ai resize
 * successivi. Va in scena solo quando shouldPlayIntroAnimation() è vera.
 */
function initIntroAnimation() {

    var panel = document.querySelector('.intro.c-panel');
    // già svelata nel frattempo (es. resize durante l'attesa dei font)
    if (!panel || panel.classList.contains('is-revealed')) { return; }

    var videoMask  = panel.querySelector('.c-video-mask');
    var video      = panel.querySelector('.c-video');
    var slot       = panel.querySelector('#video-slot');
    var whiteMask  = panel.querySelector('.c-white-mask');
    var whiteLayer = panel.querySelector('.c-content--white');

    // Sincronizza tutti gli .c-indent (dark + white) alla larghezza dello slot
    function syncIndents() {
        var w = slot.offsetWidth + 'px';
        panel.querySelectorAll('.c-indent').forEach(function (el) { el.style.width = w; });
    }

    // Posizione/dimensioni dello slot in coordinate-panel (px). Locomotive
    // Scroll v5 usa lo scroll nativo (nessun wrapper con transform), quindi
    // getBoundingClientRect() riflette sempre la posizione visuale corretta:
    // la differenza fra il rect dello slot e quello del panel è la posizione
    // relativa cercata, indipendente dai dettagli del markup in mezzo.
    function getSlotRect() {
        var panelRect = panel.getBoundingClientRect();
        var slotRect = slot.getBoundingClientRect();

        return {
            top: slotRect.top - panelRect.top,
            left: slotRect.left - panelRect.left,
            width: slotRect.width,
            height: slotRect.height,
            panelW: panelRect.width,
            panelH: panelRect.height,
        };
    }

    killIntroAnimation();
    gsap.set([videoMask, video, whiteMask, whiteLayer], { clearProps: 'all' });
    syncIndents();

    var rect = getSlotRect();

    // Contenuto dentro la mask: offset negativo per restare al posto giusto
    gsap.set([video, whiteLayer], {
        top: -rect.top, left: -rect.left,
        right: 'auto', bottom: 'auto',
        width: rect.panelW, height: rect.panelH,
    });

    // Mask parte alla posizione/dimensione dello slot, nascosta: compare
    // dopo l'ingresso dei titoli
    gsap.set([videoMask, whiteMask], { top: rect.top, left: rect.left, width: rect.width, height: rect.height, opacity: 0 });

    setIntroHeaderMode('positivo');

    // Sequenza (s): 0 titoli (CSS) → 0.9 riquadro video → 1.6 testo + cta
    // (CSS) → 2.6 espansione a schermo intero. I tempi dei testi sono in
    // pages.scss (.c-intro-in--*), avviati da .is-playing qui sotto.
    var EXPAND_AT = 1.5;
    var EXPAND_DURATION = 1.6;

    introTimeline = gsap.timeline({
        onUpdate: function () {
            // video quasi a schermo intero: header bianco (negativo),
            // altrimenti header scuro (positivo) sul fondo beige
            var expandProgress = (introTimeline.time() - EXPAND_AT) / EXPAND_DURATION;
            setIntroHeaderMode(expandProgress >= 0.7 ? 'negativo' : 'positivo');
        },
        onComplete: showIntroRevealed,
    });

    introTimeline.to(
        [videoMask, whiteMask],
        { opacity: 1, ease: 'power1.out', duration: 0.9 },
        0.9
    ).fromTo(
        [videoMask, whiteMask],
        { top: rect.top, left: rect.left, width: rect.width, height: rect.height },
        { top: 0, left: 0, width: rect.panelW, height: rect.panelH, ease: 'power2.inOut', duration: EXPAND_DURATION },
        EXPAND_AT
    ).fromTo(
        [video, whiteLayer],
        { top: -rect.top, left: -rect.left },
        { top: 0, left: 0, ease: 'power2.inOut', duration: EXPAND_DURATION },
        '<'
    );

    // avvia l'ingresso dei testi insieme alla timeline
    panel.classList.add('is-playing');
}


/**
 * Ferma l'animazione dell'intro se in corso (da chiamare prima che barba
 * sostituisca il container, per non lasciare tween agganciati a nodi
 * rimossi dal DOM).
 */
function killIntroAnimation() {
    if (introTimeline) {
        introTimeline.kill();
        introTimeline = null;
    }
}


/**
 * Avvia l'animazione intro se presente nella pagina corrente, attendendo
 * il caricamento dei font custom (altrimenti le misure dello slot sono
 * sbagliate, es. in navigazione anonima senza cache dei font).
 * Da usare solo quando la home è il punto di ingresso della sessione
 * (v. bootIntroOrRevealed).
 */
function bootIntroAnimation() {
    if (!document.querySelector('.intro.c-panel')) { return; }

    document.fonts.ready.then(function () {
        requestAnimationFrame(function () { requestAnimationFrame(initIntroAnimation); });
    });
}


/**
 * Mostra l'intro già "svelata" (video a schermo intero + testi bianchi):
 * stato finale dell'animazione, usato anche quando la home non è il punto
 * di ingresso della sessione, sotto il breakpoint desktop (v.
 * shouldPlayIntroAnimation) o al resize.
 */
function showIntroRevealed() {
    var panel = document.querySelector('.intro.c-panel');
    if (!panel) { return; }

    killIntroAnimation();
    // via le geometrie inline dell'animazione: lo stato svelato lo danno
    // le classi group-[.is-revealed]
    gsap.set(panel.querySelectorAll('.c-video-mask, .c-video, .c-white-mask, .c-content--white'), { clearProps: 'all' });
    panel.classList.add('is-revealed');
    setIntroHeaderMode('negativo');
}


// L'animazione è riservata al desktop (corrisponde al breakpoint
// "md" del progetto, v. --breakpoint-md in main.scss): sotto, si mostra
// sempre la vista già svelata.
var INTRO_ANIM_MIN_WIDTH = 960;

/**
 * True solo se la home è il punto di ingresso della sessione di navigazione
 * (v. flag window.__barbaHasLeft, impostato in barbaInit() al primo cambio
 * pagina reale via barba), la risoluzione è da desktop e l'utente non ha
 * impostato "riduci animazioni" a livello di sistema (in quel caso si mostra
 * direttamente l'intro già svelata, v. showIntroRevealed()).
 */
function shouldPlayIntroAnimation() {
    return !window.__barbaHasLeft
        && window.innerWidth >= INTRO_ANIM_MIN_WIDTH
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Decide se riprodurre l'animazione intro o mostrarla già svelata.
 */
function bootIntroOrRevealed() {
    if (shouldPlayIntroAnimation()) {
        bootIntroAnimation();
    } else {
        showIntroRevealed();
    }
}


/**
 * Al resize, sceglie video/immagine giusti per l'intro dell'home (v.
 * syncIntroMedia) e la porta allo stato svelato: l'animazione si vede solo
 * al caricamento, se è in corso viene chiusa (le geometrie calcolate non
 * sarebbero più valide). Debounced per non intervenire ad ogni singolo
 * evento di resize.
 */
var introAnimResizeTimer;
window.addEventListener('resize', function () {
    clearTimeout(introAnimResizeTimer);
    introAnimResizeTimer = setTimeout(function () {
        if (!document.querySelector('.intro.c-panel')) { return; }

        syncIntroMedia();
        showIntroRevealed();
    }, 200);
});


/**
 * Tiene in DOM un solo media per l'intro: video su desktop, immagine su
 * mobile (v. INTRO_ANIM_MIN_WIDTH), così quello non necessario non viene
 * mai scaricato dal browser. video/img partono senza src (v. data-src in
 * homepage.blade.php) e vengono referenziati una sola volta per istanza di
 * pannello (barba sostituisce il container ad ogni navigazione, quindi la
 * cache va invalidata quando cambia .c-video): l'elemento scartato viene
 * rimosso dal DOM — per il video anche l'src viene azzerato e ricaricato,
 * per interrompere un eventuale download/buffer in corso — mentre quello
 * scelto viene reinserito e gli si assegna l'src solo se non l'ha già
 * (l'img parte con il placeholder lazyload, quindi si confronta col data-src).
 */
var introMediaContainer = null;
var introVideoEl = null;
var introImgEl = null;

function syncIntroMedia() {
    var panel = document.querySelector('.intro.c-panel');
    if (!panel) { return; }

    var container = panel.querySelector('[data-intro-media]');
    if (!container) { return; }

    if (container !== introMediaContainer) {
        introMediaContainer = container;
        introVideoEl = container.querySelector('video');
        introImgEl = container.querySelector('img');
    }

    if (window.innerWidth >= INTRO_ANIM_MIN_WIDTH) {
        if (introImgEl && introImgEl.parentNode) { introImgEl.remove(); }
        if (introVideoEl) {
            if (!introVideoEl.parentNode) { introMediaContainer.appendChild(introVideoEl); }
            if (!introVideoEl.getAttribute('src')) { introVideoEl.src = introVideoEl.dataset.src; }
        }
    } else {
        if (introVideoEl && introVideoEl.parentNode) {
            introVideoEl.pause();
            introVideoEl.removeAttribute('src');
            introVideoEl.load();
            introVideoEl.remove();
        }
        if (introImgEl) {
            if (!introImgEl.parentNode) { introMediaContainer.appendChild(introImgEl); }
            if (introImgEl.getAttribute('src') !== introImgEl.dataset.src) { introImgEl.src = introImgEl.dataset.src; }
        }
    }
}


/**
 * Applica al <body> la classe "positivo"/"negativo"/"negativo-positivo"/
 * "positivo-negativo" indicata, senza toccare il DOM se è già quella
 * corrente. Gli ultimi due sono stati ibridi (v. main.scss) usati dalle
 * section con logo e menu su sfondi diversi (es. slideshow collezioni
 * prodotti).
 */
function applyHeaderMode(value) {
    // durante il cambio pagina l'header resta in positivo (v. lockHeaderModePositive)
    if (headerModeLocked) { return; }
    if (value && !$('body').hasClass(value)) {
        $('body').removeClass('positivo negativo negativo-positivo positivo-negativo').addClass(value);
    }
}


/**
 * Applica al <body> il colore header indicato dall'attributo data-header
 * di una section.
 */
function applyHeaderModeFrom(section) {
    applyHeaderMode(section.getAttribute('data-header'));
}


/**
 * Prima section della pagina (la prima con data-header nel container di
 * barba): è l'unica sotto cui l'header compare con i colori di data-header,
 * perché da lì in poi scorre via e, quando riappare, è sempre in positivo
 * (v. updateHeaderScroll).
 */
function getFirstSection() {
    return document.querySelector('[data-barba="container"] [data-header]');
}


/**
 * Applica al <body> il colore header indicato dalla prima section della
 * pagina. Chiamata al caricamento e allo sblocco dopo il cambio pagina
 * (v. unlockHeaderMode), quando il vecchio container non è più nel DOM.
 * L'intro in home cambia il data-header della sua section durante
 * l'animazione e lo applica da sé (v. setIntroHeaderMode).
 */
function updateHeaderColor() {
    var section = getFirstSection();
    if (section) { applyHeaderModeFrom(section); }
}


/**
 * Nasconde la nav fixed bottom-0 (breadcrumbs/anchor del dettaglio prodotto,
 * v. prodotti-dettaglio.blade.php) non appena il footer (.c-footer, sempre
 * presente nel layout) entra in viewport, così non resta sovrapposta al
 * footer una volta arrivati in fondo alla pagina. Richiamata ad ogni scroll
 * (v. scrollCallback di locomotiveScrollInit) invece che tenuta come istanza
 * persistente, dato che l'elemento [data-fixed-bottom-nav] viene sostituito
 * ad ogni transizione barba.
 */
function updateFixedBottomNavVisibility() {

    var nav = document.querySelector('[data-fixed-bottom-nav]');
    if (!nav) { return; }

    var footer = document.querySelector('.c-footer');
    if (!footer) { return; }

    var footerVisible = footer.getBoundingClientRect().top <= window.innerHeight;

    nav.classList.toggle('translate-y-full', footerVisible);
    nav.classList.toggle('opacity-0', footerVisible);
    nav.classList.toggle('pointer-events-none', footerVisible);
}


/**
 * Durante il cambio pagina il velo bianco (#page_loader) copre la pagina ma
 * non l'header: l'header passa quindi in positivo all'uscita (altrimenti un
 * logo bianco sparirebbe sul velo) e ci resta finché la tendina, uscendo
 * verso l'alto, non è quasi arrivata all'header (v. pageEnter), poi prende
 * il colore della nuova pagina. Nel frattempo applyHeaderMode() non ha effetto, ma gli
 * attributi data-header delle section (es. setIntroHeaderMode) vengono
 * comunque aggiornati e letti allo sblocco.
 */
var headerModeLocked = false;

function lockHeaderModePositive() {
    headerModeLocked = false;
    applyHeaderMode('positivo');
    headerModeLocked = true;
}

function unlockHeaderMode() {
    if (!headerModeLocked) { return; }

    headerModeLocked = false;
    headerScrollFrozen = false;
    updateHeaderColor();
    onPageScroll();
}


/**
 * Aggiorna l'attributo data-header="..." della section dell'intro (positivo =
 * header scuro, negativo = header bianco) e applica subito la classe
 * corrispondente al body.
 */
function setIntroHeaderMode(mode) {
    var panel = document.querySelector('.intro.c-panel');
    var section = panel && panel.closest('[data-header]');
    if (!section || section.getAttribute('data-header') === mode) { return; }

    section.setAttribute('data-header', mode);
    applyHeaderModeFrom(section);
}


/**
 * Video scrub "Outside/Interior" (v. #scrub-video in homepage.blade.php):
 * la X del mouse pilota (con lerp) il frame del video.
 * Il seek è serializzato sull'evento "seeked" per non accodare richieste
 * mentre il browser sta ancora cercando il frame precedente.
 */
var scrubVideoState = null;

function initScrubVideo(container) {

    var scope = container || document;
    var video = scope.querySelector('#scrub-video');
    if (!video) { return; }

    var section = video.closest('section');

    // il video scrub è riservato al desktop (stesso breakpoint "md" del
    // progetto, v. INTRO_ANIM_MIN_WIDTH): sotto restano solo i due blocchi
    // statici con immagine di sfondo (v. homepage.blade.php), niente video
    if (window.innerWidth < INTRO_ANIM_MIN_WIDTH) { return; }

    // ripulisce un'eventuale istanza precedente (stesso pattern di initIntroAnimation)
    killScrubVideo();

    // reduced motion: niente scrub via mousemove, il video (senza autoplay)
    // resta fermo sul poster/primo frame
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

    var state = {
        video: video,
        targetTime: 0,
        displayTime: 0,
        isSeeking: false,
        raf: null,
    };

    video.pause();

    function onReady() {
        video.pause();
        video.currentTime = 0;
        state.displayTime = 0;
        state.targetTime = 0;
    }

    if (video.readyState >= 1) {
        onReady();
    } else {
        video.addEventListener('loadedmetadata', onReady, { once: true });
    }

    state.onMouseMove = function (e) {
        if (!video.duration) { return; }

        // fuori dalla section (in quella precedente/successiva durante lo
        // scroll): il video resta fermo all'ultimo frame visualizzato
        if (section) {
            var rect = section.getBoundingClientRect();
            if (e.clientY < rect.top || e.clientY > rect.bottom) { return; }
        }

        var ratioX = e.clientX / window.innerWidth;
        state.targetTime = ratioX * video.duration;
    };

    state.onSeeked = function () {
        state.isSeeking = false;
    };

    document.addEventListener('mousemove', state.onMouseMove);
    video.addEventListener('seeked', state.onSeeked);

    function tick() {

        // video scrub
        state.displayTime += (state.targetTime - state.displayTime) * 0.1;
        if (!state.isSeeking && Math.abs(state.displayTime - video.currentTime) > 0.016) {
            state.isSeeking = true;
            video.currentTime = state.displayTime;
        }

        state.raf = requestAnimationFrame(tick);
    }

    tick();

    scrubVideoState = state;
}

/**
 * Ferma il RAF loop e rimuove i listener del video scrub, da chiamare
 * prima che barba sostituisca il container (altrimenti mousemove resta
 * agganciato a un elemento video non più in DOM).
 */
function killScrubVideo() {
    if (!scrubVideoState) { return; }

    cancelAnimationFrame(scrubVideoState.raf);
    document.removeEventListener('mousemove', scrubVideoState.onMouseMove);
    scrubVideoState.video.removeEventListener('seeked', scrubVideoState.onSeeked);

    scrubVideoState = null;
}


/**
 * Inizializza barba.js per le transizioni di pagina in ajax: definisce
 * l'animazione comune di uscita/entrata (v. transitions) e gli hook
 * specifici della home (pin/scrub-video dell'intro, v. views).
 */
function barbaInit()
{
   
    // controllo disponibilità barba
    if(typeof(barba) === "undefined") {
        return console.log("barba non disponibile");
    }

    barba.init({
        debug: window.ENV === 'local',
        logLevel: window.ENV === 'local' ? 'debug' : 'error',
        cacheIgnore:  window.ENV === 'local', // ignora cache solo in locale per sviluppo
        // il default (2s) è troppo basso per alcune pagine (es. categorie prodotti):
        // il timeout scatta anche sulle richieste avviate in prefetch all'hover del link
        timeout: 10000,
        transitions: [{
            name: 'default-transition',
            beforeLeave(data) {

                // cambio pagina in corso (v. requestError)
                window.__barbaNavigating = true;

                // url e scroll della lista prodotti che si sta lasciando (v. initTornaLista);
                // qui la pagina non è ancora stata riportata in cima (v. leave)
                onListaProdottiLeave(data);

                // memorizzo l'eventuale #hash del link cliccato: barba lo perde dopo la richiesta
                // ajax (data.next.url viene sostituito da quello di risposta, privo di hash)
                window.__barbaHash = (data.trigger && data.trigger.href)
                    ? new URL(data.trigger.href, window.location.href).hash.substring(1)
                    : '';

                // chiudo eventuali sottomenu (alpine.js) aperti nell'header
                window.dispatchEvent(new Event('close-submenu'));

                // header in positivo per tutto il cambio pagina (logo visibile sul velo bianco)
                lockHeaderModePositive();

                // header fermo nello stato attuale (anche se nascosto) fino
                // all'ingresso della nuova pagina (v. revealHeaderForPageChange)
                headerScrollFrozen = true;

                // attendi finchè loader entra prima di lasciare la pagina
                const done = this.async();

                return pageExit(function() {
                    return done();
                }, data.current.container);

            },
            leave(data) {

                // da qui in poi la home non è più il punto di ingresso della sessione
                // (v. bootIntroOrRevealed nei views)
                window.__barbaHasLeft = true;

                // rimuove dal tracking di locomotive-scroll gli elementi [data-scroll]
                // del container che sta per essere sostituito da barba
                if (locomotiveScroll) {
                    locomotiveScroll.removeScrollElements(data.current.container);
                }

                // rimuove gli split/ScrollTrigger di initTextReveal() prima che
                // il container venga rimosso dal DOM
                killTextReveal(data.current.container);

                // rimuove gli ScrollTrigger di initScrollOpacity() prima che
                // il container venga rimosso dal DOM
                killScrollOpacity(data.current.container);

                // rimuove l'intro a due colonne (v. initSplitResize)
                killSplitResize(data.current.container);

                // rimuove le istanze di initParallaxSlider() prima che
                // il container venga rimosso dal DOM
                killParallaxSlider(data.current.container);

                // rimuove il pin/scroll-reveal a slide impilate (v. initStackReveal)
                killStackReveal(data.current.container);

                if (locomotiveScroll) {
                    locomotiveScroll.scrollTo(0, {immediate:true});
                } else {
                    window.scrollTo(0, 0);
                }

            },
            // hook non utilizzati in questa transizione, lasciati per eventuali usi futuri
            afterLeave(data) {},
            beforeEnter(data) {},
            enter(data) {},
            afterEnter(data) {

                window.__barbaNavigating = false;

                // lista prodotti memorizzata / ripristino scroll (v. onListaProdottiEnter)
                onListaProdottiEnter(data);

                // registra su locomotive-scroll gli elementi [data-scroll] del nuovo container
                // (barba ha già inserito data.next.container nel DOM a questo punto)
                if (locomotiveScroll) {
                    locomotiveScroll.addScrollElements(data.next.container);

                    // le metriche (bounding rect) degli elementi appena registrati vengono
                    // calcolate subito, prima che i font custom siano necessariamente
                    // caricati: se il layout si assesta dopo (cambio di altezza righe/box),
                    // il parallax (data-scroll-speed) riceve un transform "corretto" un
                    // istante dopo quello iniziale, visibile come uno scatto dell'immagine
                    // (stesso problema già risolto per l'intro, v. bootIntroAnimation()).
                    // Un resize() dopo il caricamento font forza Locomotive a ricalcolare
                    // le metriche con il layout definitivo, idealmente prima che il loader
                    // finisca di sparire (v. pageEnter()).
                    document.fonts.ready.then(function () {
                        requestAnimationFrame(function () {
                            requestAnimationFrame(function () {
                                if (locomotiveScroll) {
                                    locomotiveScroll.resize();
                                }
                            });
                        });
                    });
                }

                // notifica i componenti alpine fuori dal container (es. x-capital-modal)
                window.dispatchEvent(new Event('barba-after-enter'));

                // tracciamento analytics: page view virtuale per GTM (tag GA4/Meta su evento barba_page_view).
                // Qui il titolo è già quello della nuova pagina, a differenza del pushState di barba.
                // page_referrer esplicito, altrimenti resterebbe il referrer del primo caricamento.
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'barba_page_view',
                    page_location: window.location.href,
                    page_title: document.title,
                    page_referrer: data.current.url.href
                });

                updateDom(data, function() {
                    pageEnter(null, window.__barbaHash, data.next.container);

                    // rebind degli eventi livewire sui nuovi contenuti caricati
                    if(window.livewire) {
                        window.livewire.rescan();
                    }

                });

            }
        }],
        views: [
            {
                namespace : 'cookies',
                afterEnter(data) {
                    // tabella cookie Cookiebot (v. initCookieDeclaration)
                    initCookieDeclaration(data.next.container);
                }
            },
            {
                namespace : 'homepage',
                leave(data) {
                    // ferma l'eventuale animazione dell'intro prima che il container venga sostituito
                    killIntroAnimation();
                    killScrubVideo();
                },
                afterEnter(data) {
                    syncIntroMedia();
                    // al primo caricamento aspetta che il loading sia sparito
                    siteLoaderDone.then(bootIntroOrRevealed);
                    initScrubVideo(data.next.container);
                }
            },
            {
                namespace : 'prodotti-categoria',
                afterEnter(data) {
                    // stato colonna filtri / vista griglia prodotti (v. initFiltriToggle, initVistaToggle)
                    initFiltriToggle(data.next.container);
                    initVistaToggle(data.next.container);
                }
            },
            {
                namespace : 'materioteca',
                leave(data) {
                    // chiude ed elimina i listener del modal dettaglio
                    // materiale prima che il container venga sostituito da
                    // barba (v. initMaterialeModal)
                    killMaterialeModal(data.current.container);
                },
                afterEnter(data) {
                    // stato colonna filtri / vista griglia materiali (v. initFiltriToggle, initVistaToggle)
                    initFiltriToggle(data.next.container);
                    initVistaToggle(data.next.container);

                    // modal dettaglio materiale, aperto al click su una
                    // anteprima (v. initMaterialeModal, MateriotecaDetail)
                    initMaterialeModal(data.next.container);
                }
            },
            {
                namespace : 'prodotti-collezioni',
                leave(data) {
                    // rimuove il pin/ScrollTrigger delle collezioni prima che
                    // il container venga sostituito da barba (v. initStackReveal)
                    killStackReveal(data.current.container);
                },
                afterEnter(data) {
                    // pin/scroll-reveal delle collezioni (v. prodotti-collezioni-outdoor.blade.php)
                    initStackReveal(data.next.container);
                }
            },
            {
                namespace : 'prodotti-dettaglio',
                leave(data) {
                    // rimuove le istanze di initGallerySlider() prima che
                    // il container venga rimosso dal DOM (lo slider parallax
                    // dei prodotti correlati è già ripulito da killParallaxSlider())
                    killGallerySlider(data.current.container);

                    // modal dettaglio tessuto/materiale (v. initMaterialeModal)
                    killMaterialeModal(data.current.container);
                },
                afterEnter(data) {
                    // modal dettaglio tessuto/materiale, aperto dalle anteprime
                    // della scheda tecnica (v. initMaterialeModal, MateriotecaDetail)
                    initMaterialeModal(data.next.container);

                    // slider galleria immagini prodotto + tab prodotti correlati
                    // (v. initGallerySlider, initProdottiTabs; lo slider parallax
                    // dei prodotti correlati è già inizializzato da initParallaxSlider())
                    initGallerySlider(data.next.container);
                    initProdottiTabs(data.next.container);

                    // link del pulsante "torna ai prodotti" alla lista di provenienza (v. initTornaLista)
                    initTornaLista(data.next.container);

                    // toggle "vedi tutti / vedi meno" della griglia moduli (v. initModuliToggle)
                    initModuliToggle(data.next.container);

                    // stato iniziale della nav fixed bottom-0, senza aspettare il primo scroll
                    updateFixedBottomNavVisibility();
                }
            }
        ],
        requestError: (trigger, action, url, response) => {
            
            console.log(trigger, action, url, response);

            // errore (404, timeout, rete...) durante un cambio pagina: la tendina
            // copre già la pagina, quindi forzo il caricamento classico dell'url.
            // Barba lo farebbe da solo solo per action 'click' e non quando la
            // richiesta è partita in prefetch all'hover (action 'enter'); in caso
            // di errore della transizione ricarica solo con logLevel 'off'
            if(action == 'click' || window.__barbaNavigating) {
                window.location.href = url;
                return false;
            }

        },
        preventRunning : true
    });
}


//icona che segue il mouse
var cursor;
function initSeguiMouse() {
    
    if ($('html').hasClass('no-touch')) {
        //rollover con icona che segue il cursore 
        cursor = $(".c-cursor");
        var $mouseX = 0,
            $mouseY = 0;
        var $xp = 0,
            $yp = 0;

        $(document).on("mousemove", function (e) {
            $mouseX = e.clientX + 7;
            $mouseY = e.clientY - 35;
        });

        var $loop = setInterval(function () {
            $xp += (($mouseX - $xp) / 5);
            $yp += (($mouseY - $yp) / 5);
            cursor.css({ left: $xp + 'px', top: $yp + 'px' });
            
        }, 30);

        updateSeguiMouse();

    }
    
}
function updateSeguiMouse() {

    
    cursor.removeClass("cursor-next cursor-prev");


    if ($('html').hasClass('no-touch')) {
        
        //cursor-prev / cursor-next: gestiti dagli slider (v. initGalleryHoverNav)

        // //scroll
        // $(".hover-scroll").on("mouseenter", function () {
        //     cursor.addClass("cursor-scroll");
        // });
        // $(".hover-scroll").on("mouseleave", function () {
        //     cursor.removeClass("cursor-scroll");
        // });
  
    }
        
}

/**
 * Aggiorna il dom.
 * Sono possibili diverse strategie (combinarle a bisogno):
 * 1. sostituire in toto l'head (questo scatena anche anche esecuzione degli script, anche inline)
 * 2. sostituire tag specifici nell'head
 * 3. - inserire script/style specifici per la nuova pagina nel container di quest'ultima.
 *    - caricare gli script in ajax, mentre eventuali tag <style> presenti nel container verranno automaticamente valutati dal browser
 * 
 * Con gli stessi sistemi si possono aggiornare elementi al di fuori del container di barba
 */
function updateDom(data, callback) {

    var html = data.next.html;
    var newHeadHtml = html.match( /<head[\s\S]*?>[\s\S]*?<\/head>/gi )[0];

    // true mantiente gli script
    var $newPageHead = $.parseHTML(newHeadHtml, document, true);


    /**
     * Aggiorno namespace di body 
     */
    $("body").attr("data-namespace", data.next.namespace);


    /**
     * Aggiorno elemento attivo menu principale
     */
    $("#page_header-mainmenu .uk-active").removeClass("uk-active");
    $('#page_header-mainmenu [data-namespace="'+data.next.namespace+'"]').addClass("uk-active");
    
    
    /**
     * aggiorno html altri elementi
     * In ogni elemento dell'array inserire:
     * - o il selettore completo
     * - o il selettore + l'attributo che si vuole rimpiazzare
     */
    [
        'head',
        '#page_header-mainmenu',
        ['#page_header .logo a', 'href'],
        '#page_footer .info_menu'
    ].forEach((selector) => {

        let realSelector = Array.isArray(selector) ? selector[0] : selector;
        let attribute = Array.isArray(selector) ? selector[1] : null;

        // recupero elemento nel nuovo html in arrivo
        let el = $(realSelector, $(data.next.html));

        // no lambda qui!
        $(realSelector).each(function() {
            if(attribute !== null) {
                // rimpiazzo attributo
                $(this).attr(attribute, el.attr(attribute));
            } else {
                // rimpiazzo contenuto html nella pagina
                $(this).html(el.html());
            }
        });

    });


    /**
     * Link del cambio lingua (header, footer, menu mobile): sono fuori dal
     * container, li punto agli alternate della nuova pagina
     */
    var newDocument = new DOMParser().parseFromString(html, 'text/html');
    document.querySelectorAll('[data-lang-switch]').forEach(function (link) {
        var newLink = newDocument.querySelector('[data-lang-switch="' + link.dataset.langSwitch + '"]');
        if (newLink) {
            link.setAttribute('href', newLink.getAttribute('href'));
        }
    });


    /**
     * 1. aggiornamento in toto dell'head
     */
    //$("head").html(newHeadHtml);

    
    /**
     * 2. aggiornamento di script specifici nell'head
     */
    $newPageHead = $( '<head />' ).html($newPageHead);
    var headTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']",
        "link[rel='alternate']"
    ].join( ',' );
    
    $( 'head' ).find( headTags ).remove();
    
    $newPageHead.find( headTags ).appendTo( 'head' );
    /**
     * 2. // fine
     */


    /**
     * 3. Caricamento degli script presenti nel container della nuova pagina
     */
    $(data.next.container).find('script').each(function (i, script) {
        var $script = $(script);

        // script linkato
        if($script.attr('src')) {
            $.getScript($script.attr('src'));
        // script inline
        } else {
            $script.appendTo('[data-barba="container"]');
        }
        
    });
    /**
     * 3. // fine
     */

    if(callback && typeof(callback) == 'function') {
        return callback();
    }

    return true;
    
}